import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import "react-dual-listbox/lib/react-dual-listbox.css";
import { Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import { addCategoryValidator } from "utils/validator";
import {
  getAreaList,
  getCollectionTypeList,
  getDoctorList,
  getStateList,
  getFranchiseTypesList,
  getPaymentModeList,
  getInvestigationList,
  getCollectionBoyList,
  getDeliveryBoyList,
  getEmployeeList,
  getZoneList,
  getBarcode,
  clearBarcode,
  getFranchiseList,
  getFranchisePackageListDD,
  getDiscountReasonList,
  getAgentList,
} from "../../redux/action/drop_list_action";
import { Offcanvas } from "react-bootstrap";
import { FaPlus, FaEye } from "react-icons/fa";
import { Overlay, Popover } from "react-bootstrap";

import {
  clearNewRegistration,
  deleteNewRegistration,
  deletePackageNewRegistration,
  submitNewRegistration,
} from "../../redux/action/new_registration_actions";
import axiosInstance from "services/axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "context/alert";
import {
  cleartRegistrationSearch,
  submitAppointmentBookingMaster,
  submitRegistrationSearch,
} from "../../redux/action/registration_search_action";
import { FormButton } from "components/Common/Buttons";
import zoneLocalStorageId from "utils/zone";
import { checkNewRegistration } from "services/newRegistration";
import { useQuery } from "@tanstack/react-query";
import { MODALS, STALE_TIME } from "utils/constants";
import MembershipCardComponent from "./MembershipCard";
import Modal from "components/Common/Modal";
import AddDoctor from "pages/DoctorMaster/AddDoctor";
import AddEmployee from "pages/PatientCoordinatorAgents/AddEmployee";
import AddPatient from "pages/PatientMaster/AddPatient";
import NewRegistrationPatientReceipt from "./NewRegistrationPatientReceipt";
import { fetchDowloadDocument } from "services/resultEntryReportMaster";
import { fetchAllocateZoneById } from "services/allocateZone";

const RegistrationForm = ({
  onClose,
  rowData,
  zoneRegistrationData,
  handleDocuments,
  documentInfo,
  setdocumentInfo,
  appointment_id,
  openPackageView,
  isThirdPartyBarcode,
  barcodeDataState,
  setDocmentAppointmentBookingId,
  sampleTypeData,
  barcodeData,
  setSampleTypeData,
  setBarcodeData,
}) => {
  const dispatch = useDispatch();
  const effectRun = useRef(false);

  const { user } = useSelector((state) => state.jwtAuthreducer);

  const employeeRoles = user?.employee_roles || [];

  const isAdminRole = employeeRoles.some(
    (role) =>
      role.role_name === "SUPER ADMIN" ||
      role.role_name === "ADMINISTRATOR" ||
      role.role_name === "ADMIN",
  );

  const openPdfFromBase64 = (base64String) => {
    const cleanBase64 = base64String.replace(/^datapdfbase64/, "");

    try {
      const byteCharacters = atob(cleanBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("PDF Error:", error);
      alert("PDF open karne mein dikkat aayi.");
    }
  };

  const canEditReferDoctor = !appointment_id || isAdminRole;

  const [showPatientModal, setShowPatientModal] = useState(false);
  const [selectedPatientIndex, setSelectedPatientIndex] = useState(0);
  const [patientList, setPatientList] = useState([]);

  const [membershipInfo, setMembershipInfo] = useState({
    membership_card_name: "",
    membership_card_no: "",
  });

  const [isAddDoctorsOpen, setIsAddDoctorsOpen] = useState(false);
  const [isAddAgentOpen, setIsAddAgentOpen] = useState(false);
  const [isAddPatientOpen, setIsAddPatientOpen] = useState(false);

  const [membershipCardData, setMembershipCardData] = useState();

  const [oldFilter, setoldFilter] = useState(false);
  const [search_mobile, setsearch_mobile] = useState();
  const [search_appoinment, setsearch_appoinment] = useState();
  const [search_patient_id, setsearch_patient_id] = useState();
  const [search_membership_card_no, setsearch_membership_card_no] = useState();
  const [membershipCardState, setMembershipCardState] = useState();
  const [search_paitent, setsearch_paitent] = useState();
  const [search_city, setsearch_city] = useState();
  const [search_state, setsearch_state] = useState();
  const [search_area, setsearch_area] = useState();
  const [search_dob, setsearch_dob] = useState();
  const [search_from, setsearch_from] = useState();
  const [search_to, setsearch_to] = useState();
  const [search_error, setsearch_error] = useState(false);
  const [patient_id, setpatient_id] = useState();
  const [receptUrl, setreceptUrl] = useState();
  const [investigationval, setinvestigationval] = useState(0);

  const [appointmentId, setappointmentId] = useState();
  const [appointmentDetailId, setappointmentDetailId] = useState();
  const [paymentDetailId, setpaymentDetailId] = useState();
  const [paymentMode, setpaymentMode] = useState();

  const [investigationIds, setInvestigationIds] = useState([]);
  const [packagesIds, setPackagesIds] = useState([]);

  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);

  const [showMembershipPopup, setShowMembershipPopup] = useState(false);
  const buttonRef = useRef(null);

  const [searchText, setSearchText] = useState("");

  const [isDocumentRequired, setIsDocumentRequired] = useState(false);
  const [showHiddenReceipt, setShowHiddenReceipt] = useState(false);

  const [
    isThirdPartyBarcodeInvestigation,
    setIsThirdPartyBarcodeInvestigation,
  ] = useState([]);

  const {
    data,
    isLoading: isLoadingDocument,
    error: isDocumentError,
  } = useQuery(
    ["fetch-signature", appointment_id],
    () => fetchDowloadDocument({ appointment_id: appointment_id }),
    {
      staleTime: STALE_TIME,
      enabled: !!appointment_id,
    },
  );

  useEffect(() => {
    // console.log("Updated Investigation IDs in useeffect :", investigationIds);
  }, [investigationIds]);

  useEffect(() => {
    if (membershipCardData) {
      setShowMembershipPopup(true);
    }
  }, [membershipCardData]);

  const deletePayload = {
    appointment_id: Number(appointment_id),
    investigation_ids: investigationIds,
  };

  const deletePackagesPayload = {
    appointment_id: Number(appointment_id),
    package_ids: packagesIds,
  };

  const appointmentBookingData = useSelector(
    (state) => state?.RegistrationSerachReducer?.appointment_booking,
  );

  const [appointmentBookingId, setAppointmentBookingId] = useState(null);
  const [docAppointmentBookingId, setDocAppointmentBookingId] = useState(null);
  const [discountType, setDiscountType] = useState(null);
  const [discountUnit, setDiscountUnit] = useState(null);

  const handleDoctorClose = async (shouldRefresh, createdDoctorData) => {
    setIsAddDoctorsOpen(false);

    if (shouldRefresh) {
      await dispatch(getDoctorList());

      if (createdDoctorData) {
        const newDoctorOption = {
          value: createdDoctorData.doctor_name,
          label: createdDoctorData.doctor_name,
          doctor_id: createdDoctorData.id,
        };

        setFieldValue("refer_doctor", newDoctorOption);
        setFieldValue("refer_doctor_id", createdDoctorData.id);
      }
    }
  };

  const handleAgentClose = async (shouldRefresh, createdDoctorData) => {
    setIsAddAgentOpen(false);

    if (shouldRefresh) {
      await dispatch(getAgentList());

      if (createdDoctorData) {
        const newDoctorOption = {
          value: createdDoctorData.agent_name,
          label: createdDoctorData.agent_name,
          agent_id: createdDoctorData.id,
        };

        setFieldValue("refer_agent", newDoctorOption);
        setFieldValue("refer_agent_id", createdDoctorData.id);
      }
    }
  };

  const handlePatientClose = async (shouldRefresh, createdPatientData) => {
    setIsAddPatientOpen(false);

    if (shouldRefresh) {
      if (createdPatientData) {
        const mobile = createdPatientData.mobile
          ? createdPatientData.mobile.split("+91")[1]
          : "";

        setFieldValue("patient_name", createdPatientData.patient_name || "");
        setFieldValue(
          "gender",
          createdPatientData.gender
            ? createdPatientData.gender.toLowerCase()
            : "",
        );

        setFieldValue("date_of_birth", createdPatientData.dob || "");
        setFieldValue("mobile", createdPatientData.mobile);
        setFieldValue("email", createdPatientData.email || "");
        setFieldValue("address", createdPatientData.address || "");
        setFieldValue("city", createdPatientData.city || "");
        setFieldValue("comments", createdPatientData.comments || "");
        setFieldValue(
          "refer_doctor_name",
          createdPatientData.refer_doctor_name || "",
        );

        setpatient_id(createdPatientData.id);

        if (createdPatientData.age) {
          const ageMatch = createdPatientData.age.match(/P(\d+)Y/);
          const years = ageMatch ? parseInt(ageMatch[1]) : 0;
          setFieldValue("age.age_year", years);
          setFieldValue("age.age_month", 0);
          setFieldValue("age.age_day", 0);
        }

        setFieldValue("company_name", createdPatientData.franchise_id || "");

        if (createdPatientData.area_id) {
          setFieldValue("area", {
            value: createdPatientData.area_id,
            label: "",
          });
        }

        if (createdPatientData.state_id) {
          setFieldValue("state", {
            value: createdPatientData.state_id,
            label: "",
          });
        }

        if (createdPatientData.refer_doctor_id) {
          setFieldValue("refer_doctor", {
            value: createdPatientData.refer_doctor_id,
            label: "",
            doctor_id: createdPatientData.refer_doctor_id,
          });
        }

        if (createdPatientData.collection_type_id) {
          setFieldValue("collection_type", {
            value: createdPatientData.collection_type_id,
            collection_type_id: createdPatientData.collection_type_id,
            label: "",
          });
        }

        if (createdPatientData.collection_boy) {
          const collectionBoy = collection_boy_list?.data?.find(
            (item) =>
              item.employee_code_id === createdPatientData.collection_boy,
          );
          if (collectionBoy) {
            setFieldValue("collection_boy", {
              value: collectionBoy.employee_name,
              label: collectionBoy.employee_name,
              payment_mode_id: collectionBoy.employee_code_id,
            });
          }
        }

        if (createdPatientData.deliver_boy) {
          const deliverBoy = collection_boy_list?.data?.find(
            (item) => item.employee_code_id === createdPatientData.deliver_boy,
          );
          if (deliverBoy) {
            setFieldValue("deliver_boy", {
              value: deliverBoy.employee_name,
              label: deliverBoy.employee_name,
              payment_mode_id: deliverBoy.employee_code_id,
            });
          }
        }
      }
    }
  };

  useEffect(() => {
    if (!effectRun.current && !appointment_id) {
      effectRun.current = true;
      dispatch(submitAppointmentBookingMaster());
    }
  }, [dispatch, appointment_id]);

  useEffect(() => {
    if (appointmentBookingData?.id) {
      setAppointmentBookingId(appointmentBookingData.id);
      setDocmentAppointmentBookingId(appointmentBookingData.id);
    }
  }, [appointmentBookingData]);

  const [searchType, setSearchType] = useState("first");

  //........end..............//
  const navigate = useNavigate();
  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  const {
    area_list,
    state_list,
    doctor_list,
    collectionType_list,
    franchiseTypes_list,
    payment_mode_list,
    investigation_list,
    collection_boy_list,
    delivery_boy_list,
    employee_list,
    zone_list,
    bar_code_info,
    franchise_list,
    franchise_package_list_dd,
    discount_reason_list,
    agent_list,
  } = useSelector((state) => state.dropListReducer);

  const _token =
    jwtAuthreducer?.token_values?.sub &&
    JSON.parse(
      jwtAuthreducer?.token_values?.sub
        .replace(/'/g, '"')
        .replace(/\bNone\b/g, "null"),
    );

  const { new_registration } = useSelector(
    (state) => state.newRegistrationReducer,
  );
  const { registration_serach } = useSelector(
    (state) => state.RegistrationSerachReducer,
  );

  const auth = useSelector((state) => state.jwtAuthreducer);

  const { data: zoneData, isLoading: isLoadingZone } = useQuery(
    ["fetch-zone-by-id", auth?.user?.employee_code_id],
    () =>
      fetchAllocateZoneById({ employee_code_id: auth?.user?.employee_code_id }),
    {
      staleTime: STALE_TIME,
      enabled: !!auth?.user?.employee_code_id,
    },
  );

  const zoneId = zoneLocalStorageId();

  const matchedZone = zoneData?.data?.find((item) => item.zone_id === zoneId);

  useEffect(() => {
    dispatch(getAreaList());
    dispatch(getStateList());
    dispatch(getDoctorList());
    dispatch(getCollectionTypeList());
    dispatch(getFranchiseTypesList());
    // dispatch(getPaymentModeList());
    dispatch(getCollectionBoyList());
    dispatch(getDeliveryBoyList());
    dispatch(getEmployeeList());
    dispatch(getZoneList());
    dispatch(getFranchiseList());
    dispatch(getInvestigationList());
    dispatch(getFranchisePackageListDD());
    dispatch(getDiscountReasonList());
    dispatch(getAgentList());
  }, []);

  useEffect(() => {
    if (!isLoadingZone && zoneData) {
      const isB2C = matchedZone?.zone_obj?.zone_type_b2c;
      dispatch(getPaymentModeList(isB2C));
    }
  }, [zoneData, isLoadingZone]);

  const updatedFranchiseId = localStorage.getItem(
    "new_registration_franchise_id",
  );

  useEffect(() => {
    if (!registration_serach?.data?.length) return;

    const dataArray = registration_serach.data;

    if (dataArray.length > 1) {
      setPatientList(dataArray);
      setShowPatientModal(true);
      return;
    }

    console.log(
      "*************************dataArray*************************",
      dataArray,
    );

    prefillPatientData(dataArray[0]);
  }, [registration_serach]);

  const prefillPatientData = (data) => {
    const mobile = data.mobile ? data.mobile.split("+91")[1] : "";

    const membershipData = data?.memberships_orders?.[0];

    setMembershipCardData({
      ...membershipData,
      patient_name: data?.patient_name,
    });

    if (membershipData) {
      setMembershipInfo({
        membership_card_name:
          membershipData?.membership_obj?.membership_card_name || "",
        membership_card_no: membershipData?.membership_card_no || "",
      });
      setMembershipCardState(membershipData?.membership_card_no);
    }

    setAppointmentBookingId(data?.appointment_booking_id);

    setappointmentId(data.appointment_id);
    setappointmentDetailId(data.appointment_detail_id);
    setpaymentDetailId(data.payment_detail_id);

    if (appointment_id) {
      setMembershipCardState(data?.membership_card_no);
      setsearch_membership_card_no(data?.membership_card_no);
      // submitSearch();
    }

    setManualAmount(data?.received_amount);
    setFieldValue("amount", data?.received_amount);

    setFieldValue("company_name", data.franchise_id);

    setFieldValue("address", data.address);
    setFieldValue("city", data.city);
    setFieldValue("patient_name", data.patient_name);
    setFieldValue("gender", data.gender);
    setFieldValue("date_of_birth", data.dob);
    setFieldValue("mobile", data.mobile);
    setFieldValue("email", data.email);
    setFieldValue("age.age_year", data.age?.year ?? 0);
    setFieldValue("age.age_month", data.age?.month ?? 0);
    setFieldValue("age.age_day", data.age?.days ?? 0);
    setFieldValue("comments", data.comments);
    setFieldValue("refer_doctor_name", data.refer_doctor_name);
    setFieldValue("refer_doctor", data?.refer_doctor_obj?.doctor_name);
    setFieldValue("refer_doctor_id", data.refer_doctor_id);
    setpatient_id(data.id);
    setFieldValue("blood_group", {
      label: data.blood_group,
      value: data.blood_group,
    });
    setFieldValue("area", {
      label: data.area_obj?.area_name,
      value: data.area_obj?.id,
    });
    setFieldValue("state", {
      label: data.state_obj?.state,
      value: data.state_obj?.state_id,
    });
    setFieldValue("LMP", Number(data.lmp));
    setFieldValue("height", Number(data.height));
    setFieldValue("weight", data.weight);

    // Doctor details
    setFieldValue("refer_doctor", {
      label: data.refer_doctor_obj?.doctor_name,
      value: data.refer_doctor_obj?.doctor_name,
      doctor_id: data.refer_doctor_obj?.id,
    });
    setFieldValue("collection_type", {
      value: data.collection_type_obj?.id,
      label: data.collection_type_obj?.collection_type,
      collection_type_id: data.collection_type_obj?.id,
    });
    setFieldValue("refer_by_hospital", data.refer_by_hospital);
    setFieldValue("lab_name", data.lab_name);

    // Collection boy details
    const collectionBoy = collection_boy_list?.data?.find(
      (item) => item.employee_code_id === data.collection_boy,
    );
    setFieldValue("collection_boy", {
      value: collectionBoy?.employee_name,
      label: collectionBoy?.employee_name,
      payment_mode_id: collectionBoy?.employee_code_id,
    });

    // Deliver boy details
    const deliverBoy = collection_boy_list?.data?.find(
      (item) => item.employee_code_id === data.deliver_boy,
    );
    setFieldValue("deliver_boy", {
      value: deliverBoy?.employee_name,
      label: deliverBoy?.employee_name,
      payment_mode_id: deliverBoy?.employee_code_id,
    });

    // Investigation details
    const investigtion_detailsinfo = (data?.investigation_data ?? [])
      .filter((item) => !item.package_id)
      .map((item) => ({
        value: item.investigation_name,
        label: item.investigation_name,
        investigation_id: item.investigation_id,
        investigation_name: item.investigation_name,
        discount_percentage: item.discount_percentage,
        discount: item.discount,
        is_urgent: "0",
        delivery_time: convertTimestampToDatetimeLocal(
          item?.delivery_time?.[0] ?? null,
        ),
        barcode_id: item?.barcode_no,
        barcode_id_main: item?.barcode_no,
        is_third_party_barcode: false,
        investigation_status_obj: item?.investigation_status_obj,
        mrp: item?.mrp,
        rate: item?.rate,
        read_only: true,
        is_active: item?.is_active,
        sample_type: item?.sample_type,
      }));

    setFieldValue("investigation_name", investigtion_detailsinfo);
    setFieldValue("investigtion_details", investigtion_detailsinfo);

    const package_detailsinfo = (data?.investigation_data ?? [])
      .filter((item) => item.package_id)
      .reduce((acc, item) => {
        let existingPackage = acc.find(
          (pkg) => pkg.package_id === item.package_id,
        );

        let appointmentPackage = data?.appointment_package_data.find(
          (ap) => ap.package_id === item.package_id,
        );

        let investigationData = {
          urgent: item.urgent,
          barcode_obj: {
            barcode_no: item.barcode_no,
          },
          rate: appointmentPackage?.rate || item.rate,
          mrp: appointmentPackage?.mrp || item.mrp,
          discount: item.discount,
          discount_percentage: item.discount_percentage,
          delivery_time: item.delivery_time,
          delivery_days: item.delivery_days,
          generated: item.generated,
          investigation_id: item.investigation_id,
          discount_by: item.discount_by,
          is_active: item.is_active,
          is_third_party_barcode: item.is_third_party_barcode,
          investigation_name: item.investigation_name,
          investigation_status_obj: item.investigation_status_obj,
          container_colour_code: item.container_colour_code,
          lab_department_name: item.lab_department_name,
          sample_type_obj: item.sample_type_obj,
        };

        if (existingPackage) {
          existingPackage.package_investigations.push(investigationData);
        } else {
          acc.push({
            package_id: item.package_id,
            package_name: appointmentPackage?.package_obj?.package_name || "",
            mrp: appointmentPackage?.mrp || item.mrp,
            rate: appointmentPackage?.rate || item.rate,
            package_investigations: [investigationData],
            discount: appointmentPackage.discount,
            discount_percentage: appointmentPackage.discount_percentage,
          });
        }

        return acc;
      }, []);

    const packageIds = [
      ...new Set(package_detailsinfo.map((item) => item.package_id)),
    ];

    setFieldValue("package_details", package_detailsinfo);
    setFieldValue("package_id", packageIds);

    // Discount & charges details
    const paymentmode = payment_mode_list?.data?.find(
      (item) => item.id === data.payment_detail_payment_mode_id,
    );
    setFieldValue("coll_charge", data.collection_charge);
    setFieldValue("coll_charge_received", data.collection_charge_received);
    setFieldValue("balance_coll_charge", data.balance_collection_charge);
    setFieldValue("adjustment", data.additional_charge);
    setFieldValue("bank_name", data.payment_detail_bank_name);
    setFieldValue("cheque_card_number", data.payment_detail_cheque_or_card_no);
    setFieldValue("cash_rendering", data.payment_detail_cash_rendering);
    setFieldValue("amount", data.payment_detail_amount);
    setFieldValue("payment_mode", {
      value: paymentmode?.payment_mode,
      label: paymentmode?.payment_mode,
      payment_mode_id: paymentmode?.id,
    });
    setFieldValue("payment_mode_id", paymentmode?.id);

    setFieldValue("discount_type", data?.discount_type);

    setFieldValue("discount_reason_id", data?.discount_reason_id);
    setFieldValue("discount_reason", data?.discount_reason);

    setFieldValue("approved_by_id", data?.discount_approved_by);

    if (
      data.discount_percentage === null ||
      data.discount_percentage === "" ||
      data.discount_percentage === 0
    ) {
      setFieldValue("discount_unit", "Amount");
      if (!values.discount) {
        setFieldValue("discount", data.discount_amount);
      }
    } else if (data.discount_percentage) {
      setFieldValue("discount_unit", "Percent");
      if (!values.discount) {
        setFieldValue("discount", data.discount_percentage);
      }
    }

    // Franchise details
    setFieldValue("franchise", {
      label: data.franchise_obj?.franchise_code,
      value: data.franchise_obj?.id,
      franchise_id: data.franchise_obj?.id,
    });
  };

  const handlePatientSelect = () => {
    const selectedPatient = patientList[selectedPatientIndex];
    prefillPatientData(selectedPatient);
    setShowPatientModal(false);
  };

  const formik = useFormik({
    initialValues: {
      zone: {},
      zone_id: "",
      patient_name: "",
      age: { age_day: "0", age_month: "0", age_year: "0" },
      date_of_birth: "",
      gender: "male",
      address: "",
      area: {},
      area_id: "",
      city: "",
      state: {},
      state_id: "",
      mobile: "",
      email: "",
      comments: "",
      weight: "",
      weight_unit: "KG",
      height: "",
      height_unit: "CM",
      LMP: "",
      blood_group: {},
      blood_group_id: "",

      // refer_doctor: {},
      refer_agent: null,
      refer_agent_id: "",
      refer_doctor: null,
      refer_doctor_id: "",
      refer_doctor_name: "",
      collection_type: {},
      collection_type_id: "",
      franchise_type: {},
      franchise_type_id: "",
      refer_by_hospital: "",
      lab_name: "",
      barcode_number: "",
      collection_boy: {},
      collection_boy_id: "",
      deliver_boy: {},
      deliver_boy_id: "",

      discount_type: "Employee Wise",
      discount: "",
      discount_unit: "Amount",
      approved_by: {},
      approved_by_id: "",
      discount_reason: "",
      coll_charge: "",
      balance_coll_charge: "",
      coll_charge_received: "",
      adjustment: "",
      payment_mode: {},
      payment_mode_id: "",
      amount: "",
      cheque_card_number: "",
      bank_name: "",
      cash_rendering: "",
      final_amount: "",
      balance_amount: "",

      investigation_name: {},
      investigation_name_id: "",
      package_name: {},
      package_name_id: "",
      investigtion_details: [],
      package_details: [],
      franchise: {},
      franchise_id: "",
      paymentModechk: "",

      appointment_booking_id: "",
    },

    validationSchema: addCategoryValidator,
    onSubmit: async ({ setSubmitting }) => {
      try {
        if (isDocumentRequired && !documentInfo?.data?.file_name) {
          showAlert("Document upload is required", "error");
          setSubmitting(false);
          return;
        }

        function buildObject(
          values,
          _token,
          jwtAuthreducer,
          calculateNetAmount,
          sumMRP,
          dateTimeStringToEpoch,
        ) {
          const result = {};
          function addIfExists(key, value) {
            if (value || key === "balance_amount") {
              result[key] = value;
            }
          }

          addIfExists("patient_name", values.patient_name);
          addIfExists(
            "age",
            "P" +
              (values.age.age_year && values.age.age_year !== ""
                ? values.age.age_year
                : 0) +
              "Y" +
              (values.age.age_month && values.age.age_month !== ""
                ? values.age.age_month
                : 0) +
              "M" +
              (values.age.age_day && values.age.age_day !== ""
                ? values.age.age_day
                : 0) +
              "D",
          );
          addIfExists("dob", values.date_of_birth);
          addIfExists("gender", values.gender);
          addIfExists("address", values.address);
          addIfExists("area_id", Number(values.area_id));
          addIfExists("city", values.city);
          addIfExists("state_id", Number(values.state_id));
          addIfExists("country_code", "IN");
          // if (values.mobile?.length === 10) {
          addIfExists("mobile", values.mobile);
          // }
          addIfExists("email", values.email);
          addIfExists("comments", values.comments);
          addIfExists("refer_doctor_id", Number(values.refer_doctor_id));
          addIfExists("agent_id", Number(values.refer_agent_id));

          addIfExists(
            "performing_doctor_id",
            Number(values.performing_doctor_id),
          );
          addIfExists("collection_type_id", Number(values.collection_type_id));
          // addIfExists("zone_id", Number(values.zone_id));
          addIfExists("zone_id", zoneLocalStorageId());
          addIfExists(
            "franchise_id",
            values.franchise_id ||
              Number(updatedFranchiseId) ||
              _token?.franchise_id,
          );
          addIfExists("approved_by", values.approved_by?.employee_code_id);
          addIfExists(
            "discount_approved_by",
            values.approved_by?.employee_code_id,
          );
          addIfExists("is_active", true);
          addIfExists("created_by", jwtAuthreducer.user.employee_code_id);
          addIfExists("weight", Number(values.weight));
          addIfExists("height", Number(values.height));
          addIfExists("height_unit", values.height_unit);
          addIfExists("lmp", Number(values.LMP));
          addIfExists("blood_group", values.blood_group_id);
          addIfExists("refer_by_hospital", values.refer_by_hospital);
          addIfExists("lab_name", values.lab_name);
          // addIfExists("barcode_no", String(values.barcode_number));
          addIfExists("payment_mode_id", Number(values.payment_mode_id));

          addIfExists("cheque_or_card_no", values.cheque_card_number);
          addIfExists("bank_name", values.bank_name);
          addIfExists("cash_rendering", Number(values.cash_rendering));
          addIfExists("patient_id", patient_id ? Number(patient_id) : "");
          addIfExists(
            "patient_document_id",
            documentInfo?.data?.id ? Number(documentInfo?.data?.id) : "",
          );
          addIfExists(
            "payment_detail_id",
            paymentDetailId ? Number(paymentDetailId) : "",
          );
          addIfExists(
            "appointment_detail_id",
            appointmentDetailId ? Number(appointmentDetailId) : "",
          );
          addIfExists(
            "appointment_id",
            appointmentId ? Number(appointmentId) : "",
          );
          addIfExists("deliver_boy", values?.deliver_boy_id);
          addIfExists("collection_boy", values?.collection_boy_id);
          addIfExists("refer_doctor_name", values?.refer_doctor_name);
          addIfExists("membership_card_no", membershipCardState);

          addIfExists(
            "balance_collection_charge",
            Number(values.balance_coll_charge),
          );
          addIfExists(
            "collection_charge_received",
            Number(values.coll_charge_received),
          );

          const netAmount = calculateNetAmount(
            sumRate(values?.investigtion_details, values?.package_details),
            values?.discount_unit,
            Number(values?.discount || 0),
            0,
            // Number(values?.coll_charge),
            Number(values?.adjustment || 0),
          );

          addIfExists(
            "amount",
            values.paymentModechk != "CASH" ? netAmount : Number(values.amount),
          );

          const totalGross = calculateNetAmount(
            sumRate(values?.investigtion_details, values?.package_details),
          );

          const totalMRP = calculateNetAmount(
            sumMRP(values?.investigtion_details, values?.package_details),
          );

          addIfExists("final_amount", totalGross);

          addIfExists("total_mrp_rate", totalMRP);

          addIfExists("discount_type", values.discount_type || discountType);

          const total = sumRate(
            values.investigtion_details,
            values?.package_details,
          );

          if (values?.discount_unit === "Amount") {
            addIfExists(
              "discount_amount",
              Math.round(Number(values.discount) || 0),
            );
          } else {
            const percent = Number(values.discount) || 0;
            const discountAmount = Math.round((total * percent) / 100);

            addIfExists("discount_amount", discountAmount);
            addIfExists("discount_percentage", percent);
          }

          addIfExists("discount_reason", values.discount_reason);
          addIfExists("discount_reason_id", Number(values.discount_reason_id));
          addIfExists("collection_charge", Number(values.coll_charge));
          addIfExists("additional_charge", Number(values.adjustment));

          const amountAfterDiscount = calculateNetAmount(
            Number(
              sumRate(
                values?.investigtion_details || [],
                values?.package_details || [],
              ) || 0,
            ),
            values?.discount_unit,
            Number(values?.discount || 0),
            0,
            Number(values?.adjustment || 0),
          );

          const amt = calculateNetAmount(
            sumRate(
              values?.investigtion_details || [],
              values?.package_details || [],
            ),
            values?.discount_unit,
            Number(values?.discount || 0),
            0,
            Number(values?.adjustment || 0),
          );

          addIfExists("amount_after_discount", amountAfterDiscount);

          (values.paymentModechk === "CASH" || paymentMode === "CASH") &&
            addIfExists(
              "balance_amount",
              amountAfterDiscount - Number(values.amount || 0),
            );

          (values.paymentModechk === "CREDIT" || paymentMode === "CREDIT") &&
            addIfExists("balance_amount", amountAfterDiscount - amt);

          addIfExists(
            "appointment_booking_id",
            appointmentBookingId || docAppointmentBookingId,
          );

          let pateint_investigtion_detailsinfo =
            values?.investigtion_details?.map((inv, index) => {
              let queryParameter = {};
              if (inv.read_only == false) {
                Object.assign(
                  queryParameter,
                  inv.investigation_id && {
                    investigation_id: Number(inv.investigation_id),
                  },
                  inv.mrp && { mrp: Number(inv.mrp) },
                  values.paymentModechk === "CASH" || paymentMode === "CASH"
                    ? {
                        discount_percentage: Number(inv.discount_percentage),
                        discount:
                          inv.mrp && inv.rate
                            ? Number(inv.mrp) - Number(inv.rate)
                            : 0,
                      }
                    : {
                        discount: inv.discount,
                      },
                  { rate: inv.rate == 0 ? Number(inv.mrp) : Number(inv.rate) },
                  inv.is_urgent && { urgent: Boolean(Number(inv.is_urgent)) },
                  inv.urgent_delivery_time && {
                    urgent_delivery_time: dateTimeStringToEpoch(
                      inv.urgent_delivery_time,
                    ),
                  },
                  {
                    delivery_time: inv.delivery_time
                      ? dateToEpochUTC(inv.delivery_time)
                      : 0,
                  },
                  inv.barcode_id && { barcode_no: String(inv.barcode_id) },
                  {
                    is_third_party_barcode:
                      isThirdPartyBarcodeInvestigation[index] || false,
                  },
                );
              }
              return queryParameter;
            });

          let newArray = pateint_investigtion_detailsinfo.filter(
            (value) => Object.keys(value).length !== 0,
          );
          addIfExists("pateint_investigtion_details", newArray);

          let patient_package_detailsinfo = values?.package_details?.map(
            (inv) => {
              let queryParameter = {};
              if (inv.read_only == false) {
                Object.assign(
                  queryParameter,
                  inv.package_id && { package_id: Number(inv?.package_id) },
                  inv.mrp && { mrp: Number(inv?.mrp) },
                  values.paymentModechk === "CASH" || paymentMode === "CASH"
                    ? {
                        discount_percentage: Number(inv.discount_percentage),
                        discount:
                          inv.mrp && inv.rate
                            ? Number(inv.mrp) - Number(inv.rate)
                            : 0,
                      }
                    : {
                        discount: Number(inv.discount),
                      },
                  {
                    rate: inv?.rate == 0 ? Number(inv?.mrp) : Number(inv?.rate),
                  },
                  inv.is_urgent && { urgent: Boolean(Number(inv?.is_urgent)) },
                  inv.urgent_delivery_time && {
                    urgent_delivery_time: dateTimeStringToEpoch(
                      inv?.urgent_delivery_time,
                    ),
                  },
                  {
                    delivery_time: inv.delivery_time
                      ? dateToEpochUTC(inv.delivery_time)
                      : 0,
                  },
                  {
                    package_investigation_detail:
                      inv.package_investigations?.map(
                        (investigation, index) => ({
                          investigation_id: investigation.investigation_id
                            ? Number(investigation.investigation_id)
                            : 0,
                          is_third_party_barcode: isThirdPartyBarcode || false,
                          barcode_no:
                            barcodeDataState[index]?.barcode_no ??
                            (investigation?.barcode_obj?.barcode_no
                              ? String(investigation.barcode_obj.barcode_no)
                              : ""),
                        }),
                      ) || [],
                  },
                );
              }
              return queryParameter;
            },
          );

          let newArrayPackage = patient_package_detailsinfo.filter(
            (value) => Object.keys(value).length !== 0,
          );
          addIfExists("patient_package_details", newArrayPackage);

          return result;
        }

        setinvestigationval(0);
        values.investigtion_details.map((inv) => {
          if (inv.mrp <= 0) {
            setinvestigationval(1);
          }
        });
        if (investigationval == 0) {
          if (investigationIds?.length) {
            await dispatch(deleteNewRegistration(deletePayload));
          }
          if (packagesIds?.length) {
            await dispatch(deletePackageNewRegistration(deletePackagesPayload));
          }
          await dispatch(
            submitNewRegistration(
              buildObject(
                values,
                _token,
                jwtAuthreducer,
                calculateNetAmount,
                sumMRP,
                dateTimeStringToEpoch,
              ),
            ),
          );

          setSearchText("");
          setFieldValue("investigation_name", {});
          setFieldValue("investigation_name_id", "");

          setFieldValue("package_name", {});
          setFieldValue("package_id", "");

          setTimeout(() => {
            dispatch(clearNewRegistration());
            dispatch(cleartRegistrationSearch());
            setsearch_membership_card_no("");
            setsearch_appoinment("");
            setsearch_patient_id("");
            setsearch_mobile("");
            setsearch_paitent("");
            setsearch_city("");
            setsearch_state("");
            setsearch_area("");
            setsearch_dob("");
            setsearch_from("");
            setsearch_to("");
            setMembershipCardData(null);
          }, 3000);
          navigate("/registration");
        }
      } catch (error) {
        showAlert(
          error.message || "Something went wrong. Please try again.",
          "danger",
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  const { errors, touched, values, handleSubmit, setFieldValue, isSubmitting } =
    formik;

  function calculateDateOfBirth(ageDays, ageMonths, ageYears) {
    if (ageYears == null || ageYears < 0) return "";
    if (ageMonths == null || ageMonths < 0 || ageMonths > 11) return "";
    if (ageDays == null || ageDays < 0) return "";

    let today = new Date();

    let birthYear = today.getFullYear() - Number(ageYears);
    let birthMonth = today.getMonth() - Number(ageMonths);
    let birthDay = today.getDate() - Number(ageDays);

    if (birthMonth < 0) {
      birthYear -= 1;
      birthMonth += 12;
    }

    if (birthDay < 0) {
      birthMonth -= 1;
      if (birthMonth < 0) {
        birthMonth = 11;
        birthYear -= 1;
      }
      let daysInPrevMonth = new Date(birthYear, birthMonth + 1, 0).getDate();
      birthDay += daysInPrevMonth;
    }

    let daysInBirthMonth = new Date(birthYear, birthMonth + 1, 0).getDate();
    if (birthDay > daysInBirthMonth) {
      birthDay = daysInBirthMonth;
    }

    let calculatedDate = new Date(birthYear, birthMonth, birthDay);
    if (
      calculatedDate.getDate() !== birthDay ||
      calculatedDate.getMonth() !== birthMonth ||
      calculatedDate.getFullYear() !== birthYear
    ) {
      return "";
    }

    return `${birthYear}-${String(birthMonth + 1).padStart(2, "0")}-${String(
      birthDay,
    ).padStart(2, "0")}`;
  }

  function calculateAge(birthDateString) {
    if (!birthDateString) return { age_year: 0, age_month: 0, age_day: 0 };

    let birthDate = new Date(birthDateString);
    let today = new Date();

    if (birthDate > today) {
      return { age_year: 0, age_month: 0, age_day: 0 };
    }

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return {
      age_year: Math.max(0, years),
      age_month: Math.max(0, months),
      age_day: Math.max(0, days),
    };
  }

  function convertTimestampToDatetimeLocal(timestamp) {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  function sumMRP(investigations, packages) {
    let totalMRP = 0;
    investigations?.forEach((investigation) => {
      let mrpValue =
        typeof investigation.mrp === "string"
          ? parseFloat(investigation.mrp)
          : investigation.mrp;
      if (!isNaN(mrpValue)) {
        totalMRP += mrpValue;
      }
    });
    packages?.forEach((packages) => {
      let mrpValue =
        typeof packages.mrp === "string"
          ? parseFloat(packages.mrp)
          : packages.mrp;
      if (!isNaN(mrpValue)) {
        totalMRP += mrpValue;
      }
    });

    return totalMRP;
  }

  function sumRate(investigations, packages) {
    let totalRate = 0;
    investigations?.forEach((investigation) => {
      let rateValue =
        typeof investigation.rate === "string"
          ? parseFloat(investigation.rate)
          : investigation.rate;
      if (!isNaN(rateValue)) {
        totalRate += rateValue;
      }
    });
    packages?.forEach((packages) => {
      let rateValue =
        typeof packages.rate === "string"
          ? parseFloat(packages.rate)
          : packages.rate;
      if (!isNaN(rateValue)) {
        totalRate += rateValue;
      }
    });
    return totalRate;
  }
  const [manualAmount, setManualAmount] = useState("");
  const [manualOverride, setManualOverride] = useState(false);

  useEffect(() => {
    if (manualOverride || !!appointment_id) return;

    const baseAmt =
      Number(sumRate(values.investigtion_details, values?.package_details)) ||
      0;

    setFieldValue(
      "amount",
      calculateNetAmount(
        baseAmt,
        values?.discount_unit,
        Number(values?.discount) || 0,
        0,
        Number(values?.adjustment) || 0,
      ),
    );
  }, [
    values.investigtion_details,
    values.package_details,
    values.discount_unit,
    values.discount,
    values.coll_charge,
    values.adjustment,
    manualOverride,
  ]);

  function calculateNetAmount(
    baseAmount,
    discountType = null,
    discountedAmo = 0,
    commissionCharges = 0,
    adjustments = 0,
  ) {
    let netAmount = baseAmount;

    if (discountType === "Amount") {
      netAmount -= discountedAmo;
    } else if (discountType === "Percent") {
      const discount = (discountedAmo / 100) * baseAmount;
      netAmount -= discount;
    }

    netAmount += commissionCharges;
    netAmount += adjustments;

    return Math.round(netAmount);
  }

  function dateTimeStringToEpoch(dateTimeString) {
    if (dateTimeString) {
      const dateTimeParts = dateTimeString.split("T");
      const dateParts = dateTimeParts[0].split("-");
      const timeParts = dateTimeParts[1].split(":");

      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const day = parseInt(dateParts[2], 10);
      const hour = parseInt(timeParts[0], 10);
      const minute = parseInt(timeParts[1], 10);

      const date = new Date(year, month, day, hour, minute, 0, 0);
      return date.getTime() / 1000;
    } else {
      return "";
    }
  }

  function dateToEpochUTC(dateString) {
    const IST_OFFSET_MS = 330 * 60 * 1000;

    if (!dateString || typeof dateString !== "string") return null;

    const parts = dateString.trim().split(/[T ]/);
    if (parts.length < 2) return null;

    const [datePart, timePart] = parts;

    const datePieces = datePart.split("-").map(Number);
    const timePieces = timePart.split(":").map(Number);

    if (datePieces.length < 3 || timePieces.length < 2) return null;

    const [year, month, day] = datePieces;
    const [hour, minute] = timePieces;

    if ([year, month, day, hour, minute].some(isNaN)) return null;

    const date = new Date(Date.UTC(year, month - 1, day, hour, minute));
    const utcDate = new Date(date.getTime() - IST_OFFSET_MS);

    return Math.floor(utcDate.getTime() / 1000);
  }

  const { showAlert } = useAlert();
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  useEffect(() => {
    if (new_registration?.patient_id) {
      showAlert(
        "Thank you! Your registration was successful! Your Appoinment ID is : " +
          new_registration?.appointment_id,
        "success",
      );

      setShowHiddenReceipt(true);

      formik.resetForm();
      setpatient_id("");
      setdocumentInfo();
    }
  }, [new_registration, new_registration?.patient_id]);

  const submitSearch = () => {
    const preservedAppointmentId = appointmentBookingId;
    // formik.resetForm();
    // dispatch(cleartRegistrationSearch());
    // dispatch(clearNewRegistration());
    setsearch_error(false);
    if (
      search_mobile == undefined &&
      search_appoinment == undefined &&
      search_paitent == undefined &&
      search_city == undefined &&
      search_state == undefined &&
      search_area == undefined &&
      search_dob == undefined &&
      search_from == undefined &&
      search_to == undefined &&
      search_membership_card_no == undefined &&
      search_patient_id == undefined
    ) {
      setsearch_error(true);
    } else if (
      search_mobile == null &&
      search_appoinment == null &&
      search_paitent == null &&
      search_city == null &&
      search_state == null &&
      search_area == null &&
      search_dob == null &&
      search_from == null &&
      search_to == null &&
      search_membership_card_no == null &&
      search_patient_id == null
    ) {
      setsearch_error(true);
    } else if (
      search_mobile == "" &&
      search_appoinment == "" &&
      search_paitent == "" &&
      search_city == "" &&
      search_state == "" &&
      search_area == "" &&
      search_dob == "" &&
      search_from == "" &&
      search_to == "" &&
      search_membership_card_no == "" &&
      search_patient_id == ""
    ) {
      setsearch_error(true);
    } else {
      setsearch_error(false);
      let searchValue = {
        mobile_no: search_mobile,
        appointment_id: search_appoinment,
        membership_card_no: search_membership_card_no,
        patient_name: search_paitent,
        city: search_city,
        state: search_state?.value,
        area: search_area?.value,
        dob: search_dob,
        date_from: search_from,
        date_to: search_to,
        patient_id: search_patient_id,
      };
      dispatch(submitRegistrationSearch(searchValue, true));

      setDiscountType("Employee Wise");
      setDiscountUnit("Amount");

      if (preservedAppointmentId) {
        setDocAppointmentBookingId(preservedAppointmentId);
        setAppointmentBookingId(preservedAppointmentId);
        setDocmentAppointmentBookingId(preservedAppointmentId);
      }
    }
  };

  useEffect(() => {
    if (appointment_id) {
      dispatch(clearNewRegistration());
      setFieldValue("address", "");
      setFieldValue("city", "");
      setFieldValue("patient_name", "");
      setFieldValue("gender", "");
      setFieldValue("date_of_birth", "");
      setFieldValue("mobile", "");
      setFieldValue("email", "");
      setFieldValue("age.age_year", "");
      setFieldValue("age.age_month", "");
      setFieldValue("age.age_day", "");
      setFieldValue("comments", "");
      setpatient_id("");
      setFieldValue("area", {});
      setFieldValue("state", {});
      let searchValue = {
        appointment_id: appointment_id,
        edit: 1,
      };
      dispatch(submitRegistrationSearch(searchValue));
    } else {
      dispatch(clearNewRegistration());
      formik.resetForm();
      setpatient_id();
      setdocumentInfo();
      setappointmentId();
      setpaymentDetailId();
      setappointmentDetailId();
    }
    //
  }, [appointment_id]);

  const franchise_id = localStorage.getItem("franchise_id");
  const new_registration_franchise_id = localStorage.getItem(
    "new_registration_franchise_id",
  );

  const defaultFranchise =
    franchise_list?.data?.find(
      (item) => item.id === parseInt(new_registration_franchise_id),
    ) ||
    franchise_list?.data?.find((item) => item.id === parseInt(franchise_id));

  const franchiseOptions = franchise_list?.data?.map((item) => ({
    value: item.company_name,
    label: `${item.company_name} , ${item.franchise_code}`,
    franchise_id: item.id,
    payment_mode: item?.payment_mode,
    allow_preprint_barcode: item?.allow_preprint_barcode,
  }));

  const selectedFranchise =
    franchiseOptions?.find(
      (opt) => opt.franchise_id === values.company_name?.franchise_id,
    ) ||
    franchiseOptions?.find((opt) => opt.franchise_id === values.company_name) ||
    (franchise_list?.data?.length === 1 ? franchiseOptions?.[0] : null) ||
    (defaultFranchise &&
      franchiseOptions?.find(
        (opt) => opt.franchise_id === defaultFranchise.id,
      ));

  useEffect(() => {
    if (franchise_list?.data?.length === 1 && !values.company_name) {
      const singleFranchise = franchise_list.data[0];
      setpaymentMode(singleFranchise?.payment_mode);
      setFieldValue("company_name", {
        value: singleFranchise.company_name,
        label: `${singleFranchise.company_name} , ${singleFranchise.franchise_code}`,
        franchise_id: singleFranchise.id,
        payment_mode: singleFranchise?.payment_mode,
        allow_preprint_barcode: singleFranchise?.allow_preprint_barcode,
      });
      setFieldValue("franchise_id", singleFranchise.id);
    }
  }, [franchise_list]);

  const newLocalFranchiseId = localStorage.getItem(
    "new_registration_franchise_id",
  );

  const franchiseIdNumber = newLocalFranchiseId
    ? Number(newLocalFranchiseId)
    : null;

  const checkFranchisePaymentMode = franchise_list?.data?.find(
    (item) => item.id === franchiseIdNumber,
  );
  useEffect(() => {
    if (selectedFranchise && appointment_id) {
      localStorage.setItem(
        "new_registration_franchise_id",
        String(selectedFranchise?.franchise_id),
      );
    }
  }, [selectedFranchise, appointment_id]);

  useEffect(() => {
    if (defaultFranchise) {
      setpaymentMode(defaultFranchise?.payment_mode);
      setFieldValue("paymentModechk", defaultFranchise?.payment_mode);
      localStorage.setItem(
        "new_registration_franchise_id",
        defaultFranchise?.id,
      );
    }
  }, [defaultFranchise, setFieldValue]);

  const ToggleInfo = ({ show, onClick }) => {
    return (
      <div
        className={`mb-3 text-white ${show ? "bg-danger" : "bg-primary"}`}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          padding: "3px 6px",
          fontSize: "12px",
          borderRadius: "4px",
          cursor: "pointer",
          userSelect: "none",
          width: "auto",
          marginLeft: "10px",
        }}
        onClick={onClick}
      >
        <i className={`fas fa-${show ? "minus" : "plus"}`}></i>{" "}
        {show ? "Hide Additional Info" : "Show Additional Info"}
      </div>
    );
  };

  const {
    data: checkNewRegistrationAllow,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery(
    ["fetch-newregistration-check", selectedFranchise?.franchise_id],
    () => checkNewRegistration(selectedFranchise?.franchise_id),
    {
      staleTime: STALE_TIME,
      enabled: !!selectedFranchise,
    },
  );

  const cursorPositionRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current && cursorPositionRef.current !== null) {
      inputRef.current.setSelectionRange(
        cursorPositionRef.current,
        cursorPositionRef.current,
      );
      cursorPositionRef.current = null;
    }
  });

  const ageYearRef = useRef(null);
  const genderRef = useRef(null);
  const referDoctorRef = useRef(null);
  const labNameRef = useRef(null);
  const investigationRef = useRef(null);
  const submitButtonRef = useRef(null);

  const [expandedInvestigations, setExpandedInvestigations] = useState({});

  const toggleInvestigationDetails = (index) => {
    setExpandedInvestigations((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    if (values?.investigtion_details?.length > 0) {
      const lastIndex = values.investigtion_details.length - 1;

      setExpandedInvestigations((prev) => {
        const hasAnyExpanded = Object.keys(prev).length > 0;

        if (hasAnyExpanded) {
          return {};
        }

        return prev;
      });
    }
  }, [values?.investigtion_details?.length]);

  useEffect(() => {
    if (barcodeData?.length > 0) {
      setFieldValue(
        "investigtion_details",
        values.investigtion_details.map((detail) => {
          const match = barcodeData.find(
            (barcodeItem) =>
              barcodeItem?.sample_type?.sample_type === detail?.sample_type,
          );
          return match
            ? { ...detail, barcode_id: match.barcode_no || "" }
            : detail;
        }),
      );
      setBarcodeData([]);
    }
  }, [barcodeData]);

  const [duplicateBarcodes, setDuplicateBarcodes] = useState(new Set());

  const checkDuplicateBarcodes = useCallback(
    (currentValue, currentSampleType, currentIndex) => {
      const duplicates = new Set();
      const barcodeMap = new Map();

      values.investigtion_details.forEach((item, index) => {
        if (
          item.barcode_id &&
          typeof item.barcode_id === "string" &&
          item.barcode_id.trim()
        ) {
          const key = item.barcode_id.trim();
          if (!barcodeMap.has(key)) {
            barcodeMap.set(key, []);
          }
          barcodeMap.get(key).push({
            index,
            sampleType: item.sample_type,
          });
        }
      });

      if (
        currentValue &&
        typeof currentValue === "string" &&
        currentValue.trim()
      ) {
        const key = currentValue.trim();
        if (!barcodeMap.has(key)) {
          barcodeMap.set(key, []);
        }

        const existingEntries = barcodeMap
          .get(key)
          .filter((entry) => entry.index !== currentIndex);
        existingEntries.push({
          index: currentIndex,
          sampleType: currentSampleType,
        });
        barcodeMap.set(key, existingEntries);
      }

      barcodeMap.forEach((entries, barcode) => {
        if (entries.length > 1) {
          const uniqueSampleTypes = [
            ...new Set(entries.map((entry) => entry.sampleType)),
          ];
          if (uniqueSampleTypes.length > 1) {
            entries.forEach((entry) => {
              duplicates.add(entry.index);
            });
          }
        }
      });

      setDuplicateBarcodes(duplicates);
      return duplicates.has(currentIndex);
    },
    [values.investigtion_details],
  );

  const getDuplicateBarcodes = useCallback((investigationDetails) => {
    const duplicates = new Set();
    const barcodeMap = new Map();

    investigationDetails.forEach((item, index) => {
      if (
        item.barcode_id &&
        typeof item.barcode_id === "string" &&
        item.barcode_id.trim()
      ) {
        const key = item.barcode_id.trim();
        if (!barcodeMap.has(key)) {
          barcodeMap.set(key, []);
        }
        barcodeMap.get(key).push({
          index,
          sampleType: item.sample_type,
        });
      }
    });

    barcodeMap.forEach((entries, barcode) => {
      if (entries.length > 1) {
        const uniqueSampleTypes = [
          ...new Set(entries.map((entry) => entry.sampleType)),
        ];
        if (uniqueSampleTypes.length > 1) {
          entries.forEach((entry) => {
            duplicates.add(entry.index);
          });
        }
      }
    });

    return duplicates;
  }, []);

  const employeeOptions = employee_list?.data?.map((item) => ({
    value: item.employee_name,
    label: `${item.employee_name} (${item.dept_obj.department})`,
    employee_code_id: item.employee_code_id,
  }));

  const selectedEmployee = employeeOptions?.find(
    (opt) => opt.employee_code_id === values.approved_by_id,
  );

  const calculateCollCharge = (collCharge, receivedCharge, setFieldValue) => {
    const balance = collCharge - receivedCharge;
    setFieldValue("balance_coll_charge", balance >= 0 ? balance : 0);
  };

  const handleShowReceipt = () => {
    const receiptData = {
      ...values,
      membership_card_no: membershipCardState || null,
    };

    localStorage.setItem("receiptData", JSON.stringify(receiptData));
    window.open("/receipt-cash-mode", "_blank");
  };

  const getInvestigationDiscountTotal = (investigations = []) => {
    return investigations.reduce((total, item) => {
      if (item?.mrp && item?.rate) {
        return total + Math.max(item.mrp - item.rate, 0);
      }
      return total + (Number(item?.discount) || 0);
    }, 0);
  };

  const getPackageDiscountTotal = (packages = []) => {
    return packages.reduce((total, item) => {
      if (item?.mrp && item?.rate) {
        return total + Math.max(item.mrp - item.rate, 0);
      }
      return total + (Number(item?.discount) || 0);
    }, 0);
  };

  const totalDiscount =
    getInvestigationDiscountTotal(values.investigtion_details) +
    getPackageDiscountTotal(values.package_details);

  const calculateDiscountPercentage = (mrp, rate) => {
    if (!mrp || mrp <= 0) return "";
    return (((mrp - rate) / mrp) * 100).toFixed(2);
  };

  useEffect(() => {
    if (membershipCardState) {
      values.investigtion_details.forEach(function (item, index) {
        var discount = calculateDiscountPercentage(item.mrp, item.rate);

        setFieldValue(
          "investigtion_details." + index + ".discount_percentage",
          discount,
        );
      });
    }
  }, [membershipCardState, values.investigtion_details]);

  useEffect(() => {
    if (membershipCardState) {
      values.package_details.forEach(function (item, index) {
        var discount = calculateDiscountPercentage(item.mrp, item.rate);

        setFieldValue(
          "package_details." + index + ".discount_percentage",
          discount,
        );
      });
    }
  }, [membershipCardState, values.package_details]);

  return (
    <div className="registration-form-container">
      <div className="box mb-4">
        <div className="boxHeader border-bottom pb-3 mb-4">
          <h1 className="col-md-3">New Registration</h1>

          <div className="col-md-3 ml-1">
            <label className="mb-2">Select Franchise</label>
            <Select
              options={franchiseOptions}
              name="franchise_dropdown"
              isDisabled={!!appointment_id}
              value={selectedFranchise}
              placeholder="Select Franchise"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              onChange={(val) => {
                setFieldValue("company_name", val);
                setFieldValue("franchise_id", val?.franchise_id);

                setpaymentMode(val?.payment_mode);

                if (val?.payment_mode !== "CASH") {
                  setFieldValue("payment_mode_id", 1);
                  setFieldValue("paymentModechk", val?.payment_mode);
                  setFieldValue("amount", 0);
                  setFieldValue("payment_mode", {
                    value: "CASH",
                    label: "CASH",
                    payment_mode_id: 1,
                  });
                } else {
                  setFieldValue("paymentModechk", val?.payment_mode);
                }

                localStorage.setItem(
                  "new_registration_franchise_id",
                  val?.franchise_id || "",
                );

                setSearchText("");
                setFieldValue("investigation_name", {});
                setFieldValue("investigation_name_id", "");

                setFieldValue("package_name", {});
                setFieldValue("package_id", "");
                setFieldValue("investigtion_details", []);
                setFieldValue("package_details", []);
              }}
            />
          </div>
          {membershipCardData &&
            (values.paymentModechk === "CASH" || paymentMode === "CASH") && (
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                <button
                  ref={buttonRef}
                  className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                  style={{ padding: "3px 6px", fontSize: "12px" }}
                  onClick={() => setShowMembershipPopup(!showMembershipPopup)}
                >
                  <FaEye size={14} /> View Membership Card
                </button>
              </div>
            )}
          <Overlay
            target={buttonRef.current}
            show={showMembershipPopup}
            placement="left"
            rootClose
            onHide={() => setShowMembershipPopup(false)}
          >
            <Popover
              id="membership-card-popover"
              style={{
                maxWidth: "700px",
                width: "450px",
              }}
            >
              <Popover.Header>
                <div className="d-flex justify-content-between align-items-center">
                  <span>Membership Card</span>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowMembershipPopup(false)}
                    aria-label="Close"
                  />
                </div>
              </Popover.Header>

              <Popover.Body>
                {membershipCardData ? (
                  <MembershipCardComponent
                    data={{ memberships_orders: [membershipCardData] }}
                  />
                ) : (
                  <p>No membership card data found.</p>
                )}
              </Popover.Body>
            </Popover>
          </Overlay>
        </div>
        <div className="boxBody border-bottom pb-3 mb-4">
          <div className="heading-form">Search Options</div>
          <div className="row">
            <div className={`col-md-2 mb-2`}>
              <label className="mb-2">Mobile Number</label>
              <input
                name="search_mobile"
                value={search_mobile}
                type="text"
                className="form-control"
                onChange={(e) => setsearch_mobile(e.target.value)}
              />
            </div>

            <div className={`col-md-2 mb-2`}>
              <label className="mb-2">Appointment ID</label>
              <input
                name="search_appoinment"
                value={search_appoinment}
                type="number"
                className="form-control"
                onChange={(e) => setsearch_appoinment(e.target.value)}
              />
            </div>

            {(values.paymentModechk === "CASH" || paymentMode === "CASH") && (
              <div className="col-md-2 mb-2">
                <label className="mb-2">Membership Card No</label>
                <input
                  name="search_membership_card_no"
                  disabled={!!appointment_id}
                  value={search_membership_card_no}
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    setsearch_membership_card_no(e.target.value);
                    setMembershipCardState(e.target.value);
                  }}
                />
              </div>
            )}

            <div className={`col-md-2 mb-2`}>
              <label className="mb-2">Reg No</label>
              <input
                name="search_patient_id"
                value={search_patient_id}
                type="text"
                className="form-control"
                onChange={(e) => setsearch_patient_id(e.target.value)}
              />
            </div>

            {oldFilter == false && (
              <div className="col-md-4">
                <button
                  className="btn btn-primary mt-4"
                  style={{ margin: "10px" }}
                  onClick={() => {
                    setoldFilter(!oldFilter);
                  }}
                >
                  {/* More Filter */}
                  <i className="fas fa-filter"></i>
                </button>
                <button
                  className="btn btn-primary mt-4"
                  style={{ margin: "10px" }}
                  onClick={() => {
                    submitSearch();
                  }}
                >
                  {/* Search */}
                  <i className="fas fa-search"></i>
                </button>
              </div>
            )}

            {oldFilter && (
              // <div className="row">
              <>
                <div className={`col-md-2 mb-2`}>
                  <label className="mb-2">Name</label>
                  <input
                    name="search_paitent"
                    type="text"
                    value={search_paitent}
                    className="form-control"
                    onChange={(e) => setsearch_paitent(e.target.value)}
                  />
                </div>
                <div className={`col-md-2 mb-2`}>
                  <label className="mb-2">Date Of Birth</label>
                  <input
                    name="search_dob"
                    type="date"
                    value={search_dob}
                    className="form-control"
                    onChange={(e) => setsearch_dob(e.target.value)}
                  />
                </div>
                <div className={`col-md-2 mb-2`}>
                  <label className="mb-2">City</label>
                  <input
                    name="search_city"
                    value={search_city}
                    type="text"
                    className="form-control"
                    onChange={(e) => setsearch_city(e.target.value)}
                  />
                </div>
                <div className={`col-md-2 mb-2`}>
                  <label className="mb-2">State</label>
                  <Select
                    name="search_state"
                    options={state_list?.map((item) => {
                      return {
                        value: item.state,
                        label: item.state,
                        state_id: item.state_id,
                      };
                    })}
                    isClearable
                    // value={search_state}
                    placeholder="Select State"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    onChange={(val) => setsearch_state(val)}
                  />
                </div>
                <div className={`col-md-2 mb-2`}>
                  <label className="mb-2">Area</label>

                  <Select
                    options={area_list?.data?.map((item) => {
                      return {
                        value: item.area_name,
                        label: item.area_name,
                        area_id: item.id,
                      };
                    })}
                    name="search_area"
                    isClearable
                    value={search_area || null}
                    placeholder="Select Area"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    onChange={(val) => setsearch_area(val)}
                  />
                </div>
                <div className={`col-md-2 mb-2`}>
                  <label className="mb-2">From</label>
                  <input
                    name="search_from"
                    type="date"
                    value={search_from}
                    className="form-control"
                    onChange={(e) => setsearch_from(e.target.value)}
                  />
                </div>

                <div className={`col-md-2 mb-2`}>
                  <label className="mb-2">To</label>
                  <input
                    name="search_to"
                    type="date"
                    value={search_to}
                    className="form-control"
                    onChange={(e) => setsearch_to(e.target.value)}
                  />
                </div>
              </>
              // </div>
            )}
          </div>
          {search_error && (
            <p className="text-danger pt-3" style={{ margin: "10px" }}>
              Please select/enter atleast one field !!
            </p>
          )}

          {oldFilter == true && (
            <button
              className="btn btn-primary mt-4"
              style={{ margin: "10px" }}
              onClick={() => {
                submitSearch();
              }}
            >
              <i className="fas fa-search"></i>
            </button>
          )}

          {oldFilter && (
            <button
              className="btn btn-primary mt-4"
              style={{ margin: "10px" }}
              onClick={() => {
                setoldFilter(!oldFilter);
              }}
            >
              Back
            </button>
          )}
        </div>
        <div className="boxBody">
          <>
            <FormikProvider value={formik}>
              <Form onSubmit={handleSubmit} noValidate>
                <div className="heading-form">Patient Details</div>

                <div className="row">
                  <div className={`col-md-3 mb-3`}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="mb-0">
                        Patient Name <span style={{ color: "red" }}>*</span>
                      </label>

                      <button
                        type="button"
                        className="btn btn-sm btn-primary d-flex align-items-center px-2 py-0"
                        style={{ fontSize: "0.7rem" }}
                        onClick={() => setIsAddPatientOpen(true)}
                      >
                        <i
                          className="fas fa-plus"
                          style={{ fontSize: "0.65rem", marginRight: "3px" }}
                        ></i>
                        Add Patient
                      </button>
                    </div>
                    <input
                      ref={inputRef}
                      name="patient_name"
                      type="text"
                      className="form-control"
                      value={values.patient_name || ""}
                      onClick={(e) => {
                        cursorPositionRef.current = e.target.selectionStart;
                      }}
                      onChange={(e) => {
                        cursorPositionRef.current = e.target.selectionStart;
                        setFieldValue(
                          "patient_name",
                          e.target.value.toUpperCase(),
                        );
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Tab") {
                          e.preventDefault();
                          setTimeout(() => ageYearRef?.current?.focus(), 0);
                        }
                      }}
                      tabIndex={1}
                    />
                    {Boolean(errors.patient_name) && (
                      <span className="text-danger">
                        {touched.patient_name && errors.patient_name}
                      </span>
                    )}
                  </div>

                  <div className={`col-md-3 mb-3`}>
                    <div>
                      <label className="mb-2">
                        Age <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="input-group">
                        <input
                          placeholder="Year"
                          name="age_year"
                          type="number"
                          className="form-control"
                          value={values.age.age_year}
                          onChange={(e) => {
                            setFieldValue("age.age_year", e.target.value);
                          }}
                          onFocus={() => {
                            if (values.age.age_year == 0) {
                              setFieldValue("age.age_year", "");
                            }
                          }}
                          onBlur={() => {
                            if (values.age.age_year == "") {
                              setFieldValue("age.age_year", 0);
                            } else {
                              setFieldValue(
                                "date_of_birth",
                                calculateDateOfBirth(
                                  values.age.age_day,
                                  values.age.age_month,
                                  values.age.age_year,
                                ),
                              );
                            }
                          }}
                          ref={ageYearRef}
                          tabIndex={2}
                          onKeyDown={(e) => {
                            if (e.key === "Tab") {
                              e.preventDefault();
                              setTimeout(() => genderRef.current?.focus(), 0);
                            }
                          }}
                        />

                        <input
                          placeholder="Month"
                          name="age_month"
                          type="number"
                          className="form-control"
                          value={values.age.age_month}
                          onChange={(e) => {
                            setFieldValue("age.age_month", e.target.value);
                          }}
                          onFocus={() => {
                            if (values.age.age_month == 0) {
                              setFieldValue("age.age_month", "");
                            }
                          }}
                          onBlur={() => {
                            if (values.age.age_month == "") {
                              setFieldValue("age.age_month", 0);
                            } else {
                              setFieldValue(
                                "date_of_birth",
                                calculateDateOfBirth(
                                  values.age.age_day,
                                  values.age.age_month,
                                  values.age.age_year,
                                ),
                              );
                            }
                          }}
                        />
                        <input
                          placeholder="Day"
                          name="age_day"
                          type="number"
                          className="form-control"
                          value={values.age.age_day}
                          onChange={(e) => {
                            setFieldValue("age.age_day", e.target.value);
                          }}
                          onFocus={() => {
                            if (values.age.age_day == 0) {
                              setFieldValue("age.age_day", "");
                            }
                          }}
                          onBlur={() => {
                            if (values.age.age_day == "") {
                              setFieldValue("age.age_day", 0);
                            } else {
                              setFieldValue(
                                "date_of_birth",
                                calculateDateOfBirth(
                                  values.age.age_day,
                                  values.age.age_month,
                                  values.age.age_year,
                                ),
                              );
                            }
                          }}
                          onKeyDown={(e) =>
                            e.key === "Tab" && genderRef.current.focus()
                          }
                        />
                      </div>
                    </div>

                    {Boolean(errors.age) && (
                      <span className="text-danger">
                        {touched.age && errors.age}
                      </span>
                    )}
                  </div>

                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">
                      Date Of Birth <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      name="date_of_birth"
                      type="date"
                      className="form-control"
                      value={values.date_of_birth}
                      onChange={(e) => {
                        setFieldValue("date_of_birth", e.target.value);
                        let { age_day, age_month, age_year } = calculateAge(
                          e.target.value,
                        );
                        setFieldValue("age.age_day", age_day);
                        setFieldValue("age.age_month", age_month);
                        setFieldValue("age.age_year", age_year);
                      }}
                    />
                    {Boolean(errors.date_of_birth) && (
                      <span className="text-danger">
                        {touched.date_of_birth && errors.date_of_birth}
                      </span>
                    )}
                  </div>

                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Gender</label>
                    <select
                      value={(values.gender || "").toLowerCase()}
                      className="form-control"
                      onChange={(e) => setFieldValue("gender", e.target.value)}
                      ref={genderRef}
                      tabIndex={3}
                      onKeyDown={(e) => {
                        if (e.key === "Tab") {
                          e.preventDefault();
                          setTimeout(() => referDoctorRef.current?.focus(), 0);
                        }
                      }}
                    >
                      {[
                        { key: "male", value: "male", label: "Male" },
                        { key: "female", value: "female", label: "Female" },
                        {
                          key: "transgender",
                          value: "transgender",
                          label: "Transgender",
                        },
                      ].map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {(values.paymentModechk === "CASH" ||
                    paymentMode === "CASH") && (
                    <>
                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Address</label>
                        <input
                          name="address"
                          type="text"
                          className="form-control"
                          value={values.address}
                          onChange={(e) =>
                            setFieldValue("address", e.target.value)
                          }
                        />
                        {Boolean(errors.address) && (
                          <span className="text-danger">
                            {touched.address && errors.address}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Mobile Number</label>
                        <input
                          name="mobile"
                          type="text"
                          className="form-control"
                          value={values.mobile}
                          onChange={(e) => {
                            const value = e.target.value.replace(
                              /[^0-9+]/g,
                              "",
                            );
                            setFieldValue("mobile", value);
                          }}
                        />
                        {Boolean(errors.mobile) && (
                          <span className="text-danger">
                            {touched.mobile && errors.mobile}
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  <div className={`col-md-3 mb-3`}>
                    <ToggleInfo
                      show={showAdditionalInfo}
                      onClick={() => setShowAdditionalInfo(!showAdditionalInfo)}
                    />
                  </div>

                  {showAdditionalInfo && (
                    <div className="row">
                      {(values.paymentModechk === "CREDIT" ||
                        paymentMode === "CREDIT") && (
                        <>
                          <div className={`col-md-3 mb-3`}>
                            <label className="mb-2">Address</label>
                            <input
                              name="address"
                              type="text"
                              className="form-control"
                              value={values.address}
                              onChange={(e) =>
                                setFieldValue("address", e.target.value)
                              }
                            />
                            {Boolean(errors.address) && (
                              <span className="text-danger">
                                {touched.address && errors.address}
                              </span>
                            )}
                          </div>

                          <div className={`col-md-3 mb-3`}>
                            <label className="mb-2">Mobile Number</label>
                            <input
                              name="mobile"
                              type="text"
                              className="form-control"
                              value={values.mobile}
                              onChange={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9+]/g,
                                  "",
                                );
                                setFieldValue("mobile", value);
                              }}
                            />
                            {Boolean(errors.mobile) && (
                              <span className="text-danger">
                                {touched.mobile && errors.mobile}
                              </span>
                            )}
                          </div>
                        </>
                      )}

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Area</label>
                        <Select
                          options={area_list?.data?.map((item) => {
                            return {
                              value: item.area_name,
                              label: item.area_name,
                              area_id: item.id,
                            };
                          })}
                          name="area"
                          isClearable
                          // value={values.area || null}
                          placeholder="Select Area"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          onChange={(val) => {
                            setFieldValue("area", val);
                            setFieldValue("area_id", val?.area_id);
                          }}
                        />
                        {Boolean(errors.area_id) && (
                          <span className="text-danger">
                            {touched.area_id && errors.area_id}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">City</label>
                        <input
                          name="city"
                          type="text"
                          className="form-control"
                          value={values.city}
                          onChange={(e) =>
                            setFieldValue("city", e.target.value)
                          }
                        />
                        {Boolean(errors.city) && (
                          <span className="text-danger">
                            {touched.city && errors.city}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">State</label>
                        <Select
                          options={state_list?.map((item) => {
                            return {
                              value: item.state,
                              label: item.state,
                              state_id: item.state_id,
                            };
                          })}
                          isClearable
                          value={values.state || null}
                          placeholder="Select State"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          onChange={(val) => {
                            setFieldValue("state", val);
                            setFieldValue("state_id", val?.state_id);
                          }}
                        />
                        {Boolean(errors.state_id) && (
                          <span className="text-danger">
                            {touched.state_id && errors.state_id}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Email ID</label>
                        <input
                          name="email"
                          type="text"
                          className="form-control"
                          value={values.email}
                          onChange={(e) =>
                            setFieldValue("email", e.target.value)
                          }
                        />
                        {Boolean(errors.email) && (
                          <span className="text-danger">
                            {touched.email && errors.email}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Weight</label>
                        <div className="input-group">
                          <input
                            type="number"
                            className="form-control"
                            aria-label="Text input with dropdown button"
                            value={values.weight}
                            onChange={(e) =>
                              setFieldValue("weight", e.target.value)
                            }
                          />
                          <button
                            className="btn btn-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {values.weight_unit}
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            <li
                              onClick={() => setFieldValue("weight_unit", "KG")}
                            >
                              <span className="dropdown-item">KG</span>
                            </li>
                          </ul>
                        </div>
                        {Boolean(errors.weight) && (
                          <span className="text-danger">
                            {touched.weight && errors.weight}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Height</label>
                        <div className="input-group">
                          <input
                            type="number"
                            className="form-control"
                            aria-label="Text input with dropdown button"
                            value={values.height}
                            onChange={(e) =>
                              setFieldValue("height", e.target.value)
                            }
                          />
                          <button
                            className="btn btn-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {values.height_unit}
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            <li
                              onClick={() => setFieldValue("height_unit", "CM")}
                            >
                              <span className="dropdown-item">CM</span>
                            </li>
                            <li
                              onClick={() => setFieldValue("height_unit", "IN")}
                            >
                              <span className="dropdown-item">IN</span>
                            </li>
                          </ul>
                        </div>
                        {Boolean(errors.height) && (
                          <span className="text-danger">
                            {touched.height && errors.height}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">LMP</label>
                        <input
                          name="LMP"
                          type="number"
                          className="form-control"
                          value={values.LMP}
                          onChange={(e) => setFieldValue("LMP", e.target.value)}
                        />
                        {Boolean(errors.LMP) && (
                          <span className="text-danger">
                            {touched.LMP && errors.LMP}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Blood Group</label>
                        <Select
                          options={[
                            {
                              value: "A",
                              label: "A",
                            },
                            {
                              value: "A+",
                              label: "A+",
                            },
                            {
                              value: "B",
                              label: "B",
                            },
                            {
                              value: "B+",
                              label: "B+",
                            },
                          ]}
                          name="refer_doctor"
                          isClearable
                          value={values.blood_group || null}
                          placeholder="Select Blood Group"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          onChange={(val) => {
                            setFieldValue("blood_group", val);
                            setFieldValue("blood_group_id", val?.value);
                          }}
                        />
                        {Boolean(errors.blood_group_id) && (
                          <span className="text-danger">
                            {touched.blood_group_id && errors.blood_group_id}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {showAdditionalInfo &&
                  (values.paymentModechk === "CREDIT" ||
                    paymentMode === "CREDIT") && (
                    <div className="row">
                      <div className="">
                        <label className="mb-2">Comments</label>
                        <textarea
                          className="form-control"
                          id="comments"
                          rows="2"
                          value={values.comments}
                          onChange={(e) =>
                            setFieldValue("comments", e.target.value)
                          }
                        ></textarea>
                      </div>
                    </div>
                  )}

                {/* Doctor Details */}

                <div className="heading-form mt-3">Doctor Details</div>

                <div className="row">
                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Refer Doctor</label>

                    {values.paymentModechk === "CASH" ||
                    paymentMode === "CASH" ? (
                      <Select
                        value={values.refer_doctor || null}
                        isDisabled={!canEditReferDoctor}
                        options={[
                          {
                            value: "add_doctor",
                            label: (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <FaPlus size={12} /> Add Doctor
                              </div>
                            ),
                            isAddDoctor: true,
                          },
                          ...(doctor_list?.map((item) => ({
                            value: item.doctor_name,
                            label: item.doctor_name,
                            doctor_id: item.id,
                          })) ?? []),
                        ]}
                        name="refer_doctor"
                        isClearable
                        placeholder="Select Doctor"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        onChange={(val) => {
                          if (val?.isAddDoctor) {
                            setFieldValue("refer_doctor", null);
                            setFieldValue("refer_doctor_id", null);
                            setIsAddDoctorsOpen(true);
                            return;
                          }

                          setFieldValue("refer_doctor", val);
                          setFieldValue("refer_doctor_id", val?.doctor_id);
                        }}
                      />
                    ) : (
                      <input
                        name="refer_doctor_name"
                        type="text"
                        className="form-control"
                        value={values?.refer_doctor_name}
                        onChange={(e) =>
                          setFieldValue(
                            "refer_doctor_name",
                            e.target.value.toUpperCase(),
                          )
                        }
                        ref={referDoctorRef}
                        tabIndex={4}
                        onKeyDown={(e) => {
                          if (e.key === "Tab") {
                            e.preventDefault();
                            setTimeout(() => labNameRef.current?.focus(), 0);
                          }
                        }}
                      />
                    )}

                    {/* Error message handling */}
                    {values.paymentModechk === "CASH"
                      ? Boolean(errors.refer_doctor_id) && (
                          <span className="text-danger">
                            {touched.refer_doctor_id && errors.refer_doctor_id}
                          </span>
                        )
                      : Boolean(errors.refer_doctor_name) && (
                          <span className="text-danger">
                            {touched.refer_doctor_name &&
                              errors.refer_doctor_name}
                          </span>
                        )}
                  </div>
                  {values.paymentModechk === "CASH" ||
                  paymentMode === "CASH" ? (
                    <div className="col-md-3 mb-3">
                      <label className="mb-2">Refer Doctor Name</label>

                      <input
                        name="refer_doctor_name"
                        type="text"
                        className="form-control"
                        value={values?.refer_doctor_name}
                        onChange={(e) =>
                          setFieldValue(
                            "refer_doctor_name",
                            e.target.value.toUpperCase(),
                          )
                        }
                        ref={referDoctorRef}
                        tabIndex={4}
                        onKeyDown={(e) => {
                          if (e.key === "Tab") {
                            e.preventDefault();
                            setTimeout(() => labNameRef.current?.focus(), 0);
                          }
                        }}
                      />

                      {Boolean(errors.refer_doctor_name) && (
                        <span className="text-danger">
                          {touched.refer_doctor_name &&
                            errors.refer_doctor_name}
                        </span>
                      )}
                    </div>
                  ) : null}
                  {values.paymentModechk === "CASH" ||
                  paymentMode === "CASH" ? (
                    <div className="col-md-3 mb-3">
                      <label className="mb-2">Agent</label>

                      <Select
                        value={values.refer_agent || null}
                        isDisabled={!canEditReferDoctor}
                        options={[
                          {
                            value: "add_doctor",
                            label: (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <FaPlus size={12} /> Add Agent
                              </div>
                            ),
                            isAddDoctor: true,
                          },
                          ...(agent_list?.map((item) => ({
                            value: item.agent_name,
                            label: item.agent_name,
                            agent_id: item.id,
                          })) ?? []),
                        ]}
                        name="refer_agent"
                        isClearable
                        placeholder="Select Agent"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        onChange={(val) => {
                          if (val?.isAddDoctor) {
                            setFieldValue("refer_agent", null);
                            setFieldValue("refer_agent_id", null);
                            setIsAddAgentOpen(true);
                            return;
                          }

                          setFieldValue("refer_agent", val);
                          setFieldValue("refer_agent_id", val?.agent_id);
                        }}
                      />

                      {Boolean(errors.refer_agent_id) && (
                        <span className="text-danger">
                          {touched.refer_agent_id && errors.refer_agent_id}
                        </span>
                      )}
                    </div>
                  ) : null}
                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Collection Type</label>
                    <Select
                      options={collectionType_list?.data?.map((item) => {
                        return {
                          value: item.collection_type,
                          label: item.collection_type,
                          collection_type_id: item.id,
                        };
                      })}
                      name="collection_type"
                      isClearable
                      value={values.collection_type || null}
                      placeholder="Select Collection Type"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      onChange={(val) => {
                        setFieldValue("collection_type", val);
                        setFieldValue(
                          "collection_type_id",
                          val.collection_type_id,
                        );
                      }}
                    />
                  </div>
                  {/* <div className={`col-md-3 mb-3`}>
              <label className="mb-2">Franchise</label>
              <Select
                options={franchiseTypes_list?.data?.map((item) => {
                  return {
                    value: item.franchise_type,
                    label: item.franchise_type,
                    franchise_id: item.id,
                  };
                })}
                name="franchise_type"
                isClearable
                value={values.franchise_type || null}
                placeholder="Select Franchise Type"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                onChange={(val) => {
                  setFieldValue("franchise_type", val);
                  setFieldValue("franchise_type_id", val.franchise_id);
                }}
              />
            </div> */}
                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Refer By Hospital</label>
                    <input
                      name="refer_by_hospital"
                      type="text"
                      className="form-control"
                      value={values.refer_by_hospital}
                      onChange={(e) =>
                        setFieldValue("refer_by_hospital", e.target.value)
                      }
                    />
                    {Boolean(errors.refer_by_hospital) && (
                      <span className="text-danger">
                        {touched.refer_by_hospital && errors.refer_by_hospital}
                      </span>
                    )}
                  </div>
                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Lab Name</label>
                    <input
                      name="lab_name"
                      type="text"
                      className="form-control"
                      value={values.lab_name}
                      onChange={(e) =>
                        setFieldValue("lab_name", e.target.value)
                      }
                      ref={labNameRef}
                      tabIndex={5}
                      onKeyDown={(e) => {
                        if (e.key === "Tab") {
                          e.preventDefault();
                          setTimeout(
                            () => investigationRef.current?.focus(),
                            0,
                          );
                        }
                      }}
                    />
                    {Boolean(errors.lab_name) && (
                      <span className="text-danger">
                        {touched.lab_name && errors.lab_name}
                      </span>
                    )}
                  </div>
                  {/* <div className={`col-md-3 mb-3`}>
                  <label className="mb-2">Barcode Number <span style={{color:"red"}}>*</span></label>
                  <input
                    name="barcode_number"
                    type="text"
                    className="form-control"
                    value={values.barcode_number}
                    onChange={(e) =>
                      setFieldValue("barcode_number", e.target.value)
                    }
                  />
                  {Boolean(errors.barcode_number) && (
                    <span className="text-danger">
                      {touched.barcode_number && errors.barcode_number}
                    </span>
                  )}
                </div> */}
                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Collection Boy</label>
                    <Select
                      options={collection_boy_list?.data?.map((item) => {
                        return {
                          value: item.employee_name,
                          label: item.employee_name,
                          employee_code_id: item.employee_code_id,
                        };
                      })}
                      name="collection_boy"
                      isClearable
                      value={values.collection_boy || null}
                      placeholder="Select Collection Boy"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      onChange={(val) => {
                        setFieldValue("collection_boy", val);
                        setFieldValue(
                          "collection_boy_id",
                          val?.employee_code_id,
                        );
                      }}
                    />
                    {Boolean(errors.collection_boy_id) && (
                      <span className="text-danger">
                        {touched.collection_boy_id && errors.collection_boy_id}
                      </span>
                    )}
                  </div>
                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Deliver Boy</label>
                    <Select
                      options={delivery_boy_list?.data?.map((item) => {
                        return {
                          value: item.employee_name,
                          label: item.employee_name,
                          employee_code_id: item.employee_code_id,
                        };
                      })}
                      name="deliver_boy"
                      isClearable
                      value={values.deliver_boy || null}
                      placeholder="Select Deliver Boy"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      onChange={(val) => {
                        setFieldValue("deliver_boy", val);
                        setFieldValue("deliver_boy_id", val?.employee_code_id);
                      }}
                    />
                    {Boolean(errors.deliver_boy_id) && (
                      <span className="text-danger">
                        {touched.deliver_boy_id && errors.deliver_boy_id}
                      </span>
                    )}
                  </div>
                  {values.paymentModechk === "CASH" && (
                    <div className="col-md-3 mb-3">
                      <label className="mb-2">Performing Doctor</label>
                      <Select
                        options={doctor_list?.map((item) => ({
                          value: item.doctor_name,
                          label: item.doctor_name,
                          performing_doctor_id: item.id,
                        }))}
                        name="performing_doctor"
                        isDisabled={!canEditReferDoctor}
                        isClearable
                        placeholder="Performing doctor"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        onChange={(val) => {
                          setFieldValue("performing_doctor", val);
                          setFieldValue(
                            "performing_doctor_id",
                            val?.performing_doctor_id,
                          );
                        }}
                      />
                    </div>
                  )}
                  {(values.paymentModechk === "CASH" ||
                    paymentMode === "CASH") && (
                    <div className="col-md-3 mb-3">
                      <label className="mb-2">Comments</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={values.comments}
                        onChange={(e) =>
                          setFieldValue("comments", e.target.value)
                        }
                      />
                    </div>
                  )}
                  <div className="col-md-3 mb-3  ">
                    <label className="">
                      Document{" "}
                      {isDocumentRequired && (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    <div>
                      <button
                        type="button"
                        className="btn btn-primary mt-2"
                        onClick={() => handleDocuments(rowData)}
                      >
                        Upload Document
                      </button>
                      {documentInfo?.data?.file_name && (
                        <span
                          style={{
                            fontSize: "15px",
                            fontWeight: "bold",
                            padding: "5px",
                          }}
                        >
                          {documentInfo?.data?.file_name}
                        </span>
                      )}
                      {isDocumentRequired && !documentInfo?.data?.file_name && (
                        <span className="text-danger d-block mt-1 fs-4 fw-bold">
                          Document upload is required
                        </span>
                      )}
                    </div>
                  </div>
                  {data?.data && (
                    <div className="col-md-3 mb-3">
                      <label className="">Uploaded Document</label>
                      {data?.data && (
                        <div className="mt-2">
                          {data.data.startsWith("JVBERi") ||
                          data.data.includes("pdf") ? (
                            <div
                              className="text-center border p-2"
                              style={{ width: "80px", cursor: "pointer" }}
                              onClick={() => openPdfFromBase64(data.data)}
                            >
                              <i
                                className="fa fa-file-pdf text-danger"
                                style={{ fontSize: "30px" }}
                              ></i>
                              <span className="d-block small mt-1 text-primary">
                                View PDF
                              </span>
                            </div>
                          ) : (
                            <img
                              src={`data:image/jpeg;base64,${data.data.replace(/^dataimage\/jpegbase64/, "")}`}
                              alt="Uploaded Doc"
                              style={{
                                objectFit: "cover",
                                borderRadius: "4px",
                                border: "1px solid #ddd",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                window.open(
                                  `data:image/jpeg;base64,${data.data.replace(/^dataimage\/jpegbase64/, "")}`,
                                  "_blank",
                                )
                              }
                            />
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Investigation Details */}

                <>
                  <div className="heading-form mt-3 text-primary">
                    Investigation Details
                  </div>
                  <div className="mb-2 d-flex align-items-center">
                    <div className="form-check form-check-inline">
                      <label className="form-check-label">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="searchType"
                          value="first"
                          checked={searchType === "first"}
                          onChange={() => setSearchType("first")}
                        />
                        Search by First Name
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <label className="form-check-label">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="searchType"
                          value="full"
                          checked={searchType === "full"}
                          onChange={() => setSearchType("full")}
                        />
                        Search by Full Name (In-Between)
                      </label>
                    </div>
                  </div>
                  <FieldArray name="investigtion_details">
                    {({ insert, remove, push }) => (
                      <>
                        <div className="row">
                          <div className="d-flex align-items-end">
                            <div style={{ flex: 1 }}>
                              <Select
                                ref={investigationRef}
                                tabIndex={6}
                                onKeyDown={(e) => {
                                  if (e.key === "Tab") {
                                    e.preventDefault();
                                    setTimeout(
                                      () => submitButtonRef.current?.focus(),
                                      0,
                                    );
                                  }
                                }}
                                options={investigation_list?.data?.map(
                                  (item) => {
                                    return {
                                      value: item?.investigation_name,
                                      label: item?.investigation_name,
                                      investigation_id: item?.id,
                                    };
                                  },
                                )}
                                onSearch={(value) => setSearchText(value)}
                                filterOption={(option, inputValue) => {
                                  const labelText =
                                    option.label?.toLowerCase() || "";
                                  const input = inputValue.toLowerCase();

                                  if (searchType === "first") {
                                    const startsWithMatch =
                                      labelText.startsWith(input);
                                    return startsWithMatch;
                                  } else {
                                    return labelText.includes(input);
                                  }
                                }}
                                filterSort={(optionA, optionB) => {
                                  if (searchType !== "first") return 0;

                                  const input = searchText.toLowerCase();
                                  const a = optionA.label.toLowerCase();
                                  const b = optionB.label.toLowerCase();

                                  const startsWithA = a.startsWith(input);
                                  const startsWithB = b.startsWith(input);

                                  if (startsWithA && !startsWithB) return -1;
                                  if (!startsWithA && startsWithB) return 1;

                                  return a.localeCompare(b);
                                }}
                                name="investigation_name"
                                value={
                                  values.investigation_name &&
                                  values.investigation_name.value
                                    ? values.investigation_name
                                    : null
                                }
                                isClearable
                                placeholder="Select Investigation Name"
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                onChange={async (val) => {
                                  setFieldValue("investigation_name", val);
                                  setFieldValue(
                                    "investigation_name_id",
                                    val?.investigation_id,
                                  );
                                  let franchiseIdToUse =
                                    values?.franchise_id ||
                                    _token?.franchise_id ||
                                    franchise_id;
                                  if (!values?.franchise_id) {
                                    const storedFranchiseId =
                                      localStorage.getItem(
                                        "new_registration_franchise_id",
                                      );
                                    if (storedFranchiseId) {
                                      franchiseIdToUse = storedFranchiseId;
                                    }
                                  }
                                  if (val) {
                                    if (franchiseIdToUse) {
                                      let data1 = await axiosInstance.get(
                                        `medicity/rate/list/${
                                          val?.investigation_id
                                        }/${franchiseIdToUse}${
                                          membershipCardState
                                            ? `?membership_card_no=${membershipCardState}`
                                            : ""
                                        }`,
                                      );

                                      let rateData = data1?.data[0];
                                      setIsDocumentRequired(
                                        rateData?.upload_required === true,
                                      );

                                      const { data } = await axiosInstance.get(
                                        `medicity/franchise/get/barcode?franchise_id=${franchiseIdToUse}&investigation_id=${
                                          val?.investigation_id
                                        }&appointment_booking_id=${
                                          appointmentBookingData?.id ||
                                          appointmentBookingId ||
                                          docAppointmentBookingId
                                        }${
                                          rateData?.sample_type
                                            ? `&sample_type=${rateData.sample_type}`
                                            : ""
                                        }`,
                                      );

                                      const currentFranchise =
                                        franchiseOptions?.find(
                                          (franchise) =>
                                            franchise.franchise_id ==
                                            franchiseIdToUse,
                                        );

                                      console.log(
                                        "**********************currentFranchise**********************",
                                        currentFranchise,
                                      );

                                      const shouldIncludeBarcode =
                                        currentFranchise?.allow_preprint_barcode !==
                                        true;

                                      let barcodedataFinal = data?.barcode_no;
                                      const hasInvestigation = (
                                        list,
                                        investigationId,
                                      ) =>
                                        list?.length > 0 &&
                                        list.some(
                                          (item) =>
                                            item.investigation_id ===
                                            investigationId,
                                        );

                                      const already =
                                        hasInvestigation(
                                          values?.package_details?.[0]
                                            ?.package_investigations,
                                          val?.investigation_id,
                                        ) ||
                                        hasInvestigation(
                                          values?.investigtion_details,
                                          val?.investigation_id,
                                        );
                                      console.log(
                                        "paymentMode",
                                        values?.paymentModechk,
                                      );
                                      if (
                                        rateData?.rate === 0 ||
                                        rateData?.mrp_rate === 0
                                      ) {
                                        alert("Please Contact To Admin !!");
                                      } else if (
                                        rateData?.mrp_rate > 0 &&
                                        !already
                                      ) {
                                        const newIndex =
                                          values?.investigtion_details
                                            ?.length || 0;
                                        push({
                                          investigation_id:
                                            val?.investigation_id,
                                          investigation_name: val?.value,
                                          discount: 0,
                                          mrp: rateData?.mrp_rate,
                                          rate: rateData?.rate,
                                          is_urgent: "0",
                                          delivery_time:
                                            // convertTimestampToDatetimeLocal(
                                            rateData?.delivery_days,
                                          // ),
                                          // barcode_id: barcodedataFinal,
                                          // barcode_id_main: barcodedataFinal,
                                          ...(shouldIncludeBarcode && {
                                            barcode_id: barcodedataFinal,
                                            barcode_id_main: barcodedataFinal,
                                          }),
                                          is_third_party_barcode: false,
                                          read_only: false,
                                          sample_type: rateData?.sample_type,
                                          delivery_days:
                                            rateData?.delivery_days,
                                        });
                                        setTimeout(() => {
                                          setExpandedInvestigations((prev) => ({
                                            ...prev,
                                            [newIndex]: true,
                                          }));
                                        }, 100);
                                      } else {
                                        if (already) {
                                          alert(
                                            "Already Investigation Mapped !!",
                                          );
                                        }
                                      }
                                    }
                                  }

                                  if (paymentMode != "CASH") {
                                    setFieldValue("payment_mode_id", 1);
                                    setFieldValue(
                                      "paymentModechk",
                                      values.paymentModechk
                                        ? values.paymentModechk
                                        : paymentMode,
                                    );
                                    setFieldValue("amount", 0);
                                    setFieldValue("payment_mode", {
                                      value: "CASH",
                                      label: "CASH",
                                      payment_mode_id: 1,
                                    });
                                  } else {
                                    setFieldValue(
                                      "paymentModechk",
                                      values.paymentModechk
                                        ? values.paymentModechk
                                        : paymentMode,
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {values?.investigtion_details.map((field, index) => {
                          const previousIndex =
                            values.investigtion_details.findIndex(
                              (item, idx) =>
                                item.sample_type === field.sample_type &&
                                idx < index,
                            );

                          const isFirstOccurrence = previousIndex === -1;
                          const referenceIndex = isFirstOccurrence
                            ? index
                            : previousIndex;
                          const isLastInvestigation =
                            index === values?.investigtion_details.length - 1;

                          // Cash mode check - agar CASH mode hai to hamesha details show karo
                          const isCashMode =
                            values.paymentModechk === "CASH" ||
                            paymentMode === "CASH";

                          const shouldShowDetails =
                            isCashMode ||
                            expandedInvestigations[index] ||
                            isLastInvestigation;

                          const currentDuplicates = getDuplicateBarcodes(
                            values.investigtion_details,
                          );
                          const hasDuplicateBarcode =
                            currentDuplicates.has(index);

                          return (
                            <div className="" key={index}>
                              <div
                                className="block-box"
                                style={{ opacity: field.isDisabled ? 0.5 : 1 }}
                              >
                                <div
                                  className="p-2 text-primary d-flex align-items-center justify-content-between"
                                  style={{
                                    fontSize: "14px",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "16px",
                                  }}
                                >
                                  <span
                                    style={{
                                      flex: 1,
                                      minWidth: "100px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {
                                      values?.investigtion_details[index]
                                        ?.investigation_name
                                    }
                                  </span>

                                  <span
                                    style={{
                                      flex: 1,
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      minWidth: "150px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <span style={{ whiteSpace: "nowrap" }}>
                                      Barcode:
                                    </span>
                                    <Field
                                      name={`investigtion_details.${index}.barcode_id`}
                                      type="text"
                                      className="text-input"
                                      disabled={
                                        !!(
                                          appointment_id &&
                                          values?.investigtion_details?.[index]
                                            ?.read_only
                                        )
                                      }
                                      value={
                                        values.investigtion_details[
                                          referenceIndex
                                        ]?.barcode_id || ""
                                      }
                                      onChange={(e) => {
                                        const newValue = e.target.value
                                          .replace(/[^a-zA-Z0-9\-_/+]/g, "")
                                          .toUpperCase();

                                        setFieldValue(
                                          `investigtion_details.${referenceIndex}.barcode_id`,
                                          newValue,
                                        );

                                        const isDuplicate =
                                          checkDuplicateBarcodes(
                                            newValue,
                                            field.sample_type,
                                            referenceIndex,
                                          );

                                        values.package_details?.forEach(
                                          (pkg, pkgIdx) => {
                                            pkg.package_investigations?.forEach(
                                              (investigation, invIdx) => {
                                                const matchedSampleType =
                                                  investigation.sample_type_obj?.find(
                                                    (st) =>
                                                      st.sample_type ===
                                                      field.sample_type,
                                                  );

                                                if (matchedSampleType) {
                                                  setFieldValue(
                                                    `package_details.${pkgIdx}.package_investigations.${invIdx}.barcode_obj.barcode_no`,
                                                    newValue,
                                                  );
                                                }
                                              },
                                            );
                                          },
                                        );

                                        setIsThirdPartyBarcodeInvestigation(
                                          (prev) => {
                                            const updatedState = [...prev];
                                            values.investigtion_details.forEach(
                                              (item, idx) => {
                                                if (
                                                  item.sample_type ===
                                                  field.sample_type
                                                ) {
                                                  updatedState[idx] = true;
                                                  setFieldValue(
                                                    `investigtion_details.${idx}.barcode_id`,
                                                    newValue,
                                                  );
                                                }
                                              },
                                            );
                                            return updatedState;
                                          },
                                        );

                                        values.investigtion_details.forEach(
                                          (item, idx) => {
                                            if (
                                              item.sample_type ===
                                                field.sample_type &&
                                              idx !== referenceIndex
                                            ) {
                                              setFieldValue(
                                                `investigtion_details.${idx}.barcode_id`,
                                                newValue,
                                              );
                                            }
                                          },
                                        );
                                      }}
                                      style={{
                                        flex: 1,
                                        maxWidth: "100%",
                                        border: hasDuplicateBarcode
                                          ? "2px solid #ff4444"
                                          : "1px solid #ccc",
                                        backgroundColor: hasDuplicateBarcode
                                          ? "#ffebee"
                                          : appointment_id &&
                                              values?.investigtion_details?.[
                                                index
                                              ]?.read_only
                                            ? "#e9ecef"
                                            : "white",
                                      }}
                                    />
                                    {hasDuplicateBarcode && (
                                      <div
                                        style={{
                                          color: "#ff4444",
                                          fontSize: "12px",
                                          width: "100%",
                                          textAlign: "left",
                                          marginTop: "4px",
                                          padding: "4px 8px",
                                          backgroundColor: "#ffebee",
                                          borderRadius: "4px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "4px",
                                        }}
                                      >
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                        >
                                          <circle
                                            cx="12"
                                            cy="12"
                                            r="10"
                                          ></circle>
                                          <line
                                            x1="12"
                                            y1="8"
                                            x2="12"
                                            y2="12"
                                          ></line>
                                          <line
                                            x1="12"
                                            y1="16"
                                            x2="12.01"
                                            y2="16"
                                          ></line>
                                        </svg>
                                        ⚠️ This barcode is already used for a
                                        different sample type
                                      </div>
                                    )}
                                  </span>

                                  <span
                                    style={{
                                      flex: 1,
                                      whiteSpace: "nowrap",
                                      textAlign: "right",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-end",
                                      gap: "8px",
                                    }}
                                  >
                                    {
                                      values?.investigtion_details[index]
                                        ?.sample_type
                                    }
                                    {/* Show/Hide button sirf non-cash mode aur non-last investigation ke liye */}
                                    {!isLastInvestigation && !isCashMode && (
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "4px",
                                          background: "#f0f0f0",
                                          borderRadius: "4px",
                                          marginRight: "8px",
                                        }}
                                        onClick={() =>
                                          toggleInvestigationDetails(index)
                                        }
                                        title={
                                          shouldShowDetails
                                            ? "Hide Details"
                                            : "Show Details"
                                        }
                                      >
                                        {shouldShowDetails ? (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                          >
                                            <polyline points="18,15 12,9 6,15"></polyline>
                                          </svg>
                                        ) : (
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                          >
                                            <polyline points="6,9 12,15 18,9"></polyline>
                                          </svg>
                                        )}
                                      </div>
                                    )}
                                  </span>

                                  {(!appointment_id ||
                                    [
                                      "RECEIVED",
                                      "COLLECTED",
                                      "PENDING",
                                      "NOT_APPROVED",
                                    ].includes(
                                      values?.investigtion_details[index]
                                        ?.investigation_status_obj?.status,
                                    )) && (
                                    <div
                                      className="col-md-1 col-12 d-flex align-items-center justify-content-center"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setInvestigationIds((prev) => [
                                          ...prev,
                                          field.investigation_id,
                                        ]);

                                        const updatedInvestigationDetails =
                                          values?.investigtion_details?.filter(
                                            (_, i) => i !== index,
                                          );

                                        setFieldValue(
                                          "investigtion_details",
                                          updatedInvestigationDetails,
                                        );
                                        setExpandedInvestigations((prev) => {
                                          const newState = { ...prev };
                                          delete newState[index];
                                          return newState;
                                        });
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-x"
                                      >
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                      </svg>
                                    </div>
                                  )}
                                </div>

                                <style>
                                  {`
            @media (max-width: 768px) {
              .p-2 {
                flex-direction: column;
                align-items: flex-start !important;
                font-size: 12px;
              }

              .text-input {
                width: 100% !important;
              }

              .d-flex {
                gap: 8px !important;
              }
            }
          `}
                                </style>

                                {shouldShowDetails && (
                                  <div className="block-title">
                                    <div
                                      className="row"
                                      style={{
                                        width: "100%",
                                        margin: "0",
                                        padding: "10px 0",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <div className="col-md-2 col-12 d-flex flex-column p-0">
                                        <label className="in-label">
                                          Test MRP
                                        </label>
                                        <Field
                                          name={`investigtion_details.${index}.mrp`}
                                          type="number"
                                          className="text-input"
                                          disabled
                                          value={Math.ceil(
                                            values.investigtion_details[index]
                                              .mrp,
                                          )}
                                          onChange={(e) =>
                                            setFieldValue(
                                              `investigtion_details.${index}.mrp`,
                                              e.target.value,
                                            )
                                          }
                                          style={{
                                            border:
                                              values.investigtion_details[index]
                                                .mrp <= 0
                                                ? "1px solid red"
                                                : "",
                                          }}
                                        />
                                      </div>

                                      {values.paymentModechk === "CASH" ||
                                      paymentMode === "CASH" ? (
                                        <div className="col-md-2 col-12 d-flex flex-column p-0">
                                          <label className="in-label">
                                            Discount % (Amt)
                                          </label>
                                          <div className="d-flex gap-1">
                                            <Field
                                              name={`investigtion_details.${index}.discount_percentage`}
                                              type="text"
                                              className="text-input"
                                              style={{ width: "50%" }}
                                              placeholder="%"
                                              disabled={!!membershipCardState}
                                              value={
                                                membershipCardState
                                                  ? values.investigtion_details[
                                                      index
                                                    ].mrp > 0
                                                    ? (
                                                        ((values
                                                          .investigtion_details[
                                                          index
                                                        ].mrp -
                                                          values
                                                            .investigtion_details[
                                                            index
                                                          ].rate) /
                                                          values
                                                            .investigtion_details[
                                                            index
                                                          ].mrp) *
                                                        100
                                                      ).toFixed(2)
                                                    : ""
                                                  : values.investigtion_details[
                                                      index
                                                    ].discount_percentage || ""
                                              }
                                              onChange={(e) => {
                                                const discount = Number(
                                                  e.target.value || 0,
                                                );
                                                const mrp = Number(
                                                  values.investigtion_details[
                                                    index
                                                  ].mrp || 0,
                                                );

                                                const calculatedRate =
                                                  mrp - (mrp * discount) / 100;

                                                setFieldValue(
                                                  `investigtion_details.${index}.discount_percentage`,
                                                  discount,
                                                );

                                                setFieldValue(
                                                  `investigtion_details.${index}.rate`,
                                                  Math.ceil(calculatedRate),
                                                );
                                              }}
                                            />

                                            <input
                                              type="text"
                                              className="text-input"
                                              style={{ width: "50%" }}
                                              placeholder="Amt"
                                              disabled
                                              value={
                                                values.investigtion_details[
                                                  index
                                                ].mrp &&
                                                values.investigtion_details[
                                                  index
                                                ].rate
                                                  ? (
                                                      values
                                                        .investigtion_details[
                                                        index
                                                      ].mrp -
                                                      values
                                                        .investigtion_details[
                                                        index
                                                      ].rate
                                                    ).toFixed(2)
                                                  : values.investigtion_details[
                                                      index
                                                    ].discount || ""
                                              }
                                              readOnly
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="col-md-2 col-12 d-flex flex-column p-0">
                                          <label className="in-label">
                                            Test Discount
                                          </label>
                                          <Field
                                            name={`investigtion_details.${index}.discount`}
                                            type="number"
                                            className="text-input"
                                            disabled
                                            value={
                                              values.investigtion_details[index]
                                                .discount
                                            }
                                            onChange={(e) =>
                                              setFieldValue(
                                                `investigtion_details.${index}.discount`,
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      )}

                                      <div className="col-md-2 col-12 d-flex flex-column p-0">
                                        <label className="in-label">
                                          Test Rate
                                        </label>
                                        <Field
                                          name={`investigtion_details.${index}.rate`}
                                          type="number"
                                          className="text-input"
                                          disabled
                                          value={Math.ceil(
                                            values.investigtion_details[index]
                                              .rate,
                                          )}
                                          onChange={(e) =>
                                            setFieldValue(
                                              `investigtion_details.${index}.rate`,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>

                                      <div className="col-md-1 col-12 d-flex flex-column p-0">
                                        <label className="in-label">
                                          Is Urgent
                                        </label>
                                        <Field
                                          name={`investigtion_details.${index}.is_urgent`}
                                          as="select"
                                          className="text-input"
                                          disabled={
                                            values.investigtion_details[index]
                                              .read_only
                                          }
                                        >
                                          <option value="1">Yes</option>
                                          <option value="0">No</option>
                                        </Field>
                                      </div>

                                      {values.investigtion_details[index]
                                        .is_urgent === "1" && (
                                        <div className="col-md-2 col-12 d-flex flex-column p-0">
                                          <label className="in-label">
                                            Urgent Delivery Time
                                          </label>
                                          <Field
                                            name={`investigtion_details.${index}.urgent_delivery_time`}
                                            type="datetime-local"
                                            className="text-input"
                                            disabled={
                                              values.investigtion_details[index]
                                                .read_only
                                            }
                                            value={
                                              values.investigtion_details[index]
                                                .urgent_delivery_time
                                            }
                                            onChange={(e) =>
                                              setFieldValue(
                                                `investigtion_details.${index}.urgent_delivery_time`,
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      )}

                                      <div className="col-md-2 col-12 d-flex flex-column p-0">
                                        <label className="in-label">DD</label>
                                        <Field
                                          name={`investigtion_details.${index}.delivery_days`}
                                          type="number"
                                          className="text-input"
                                          disabled
                                          value={
                                            values.investigtion_details[index]
                                              .delivery_days
                                          }
                                          onChange={(e) =>
                                            setFieldValue(
                                              `investigtion_details.${index}.delivery_days`,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>

                                      <div className="col-md-2 col-12 d-flex flex-column p-0">
                                        <label className="in-label">
                                          Delivery Time
                                        </label>
                                        <Field
                                          name={`investigtion_details.${index}.delivery_time`}
                                          type="datetime-local"
                                          className="text-input"
                                          disabled={
                                            values.investigtion_details[index]
                                              .read_only
                                          }
                                          value={
                                            values.investigtion_details[index]
                                              .delivery_time
                                          }
                                          onChange={(e) =>
                                            setFieldValue(
                                              `investigtion_details.${index}.delivery_time`,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </>
                    )}
                  </FieldArray>
                </>

                {/* Package Details */}

                <>
                  <div className="heading-form mt-3 text-primary">Packages</div>
                  <FieldArray name="package_details">
                    {({ insert, remove, push }) => (
                      <>
                        <div className="row">
                          <div className="d-flex align-items-end">
                            <div style={{ flex: 1 }}>
                              <Select
                                options={franchise_package_list_dd?.map(
                                  (item) => {
                                    return {
                                      value: item?.package_id,
                                      label: item?.package_name,
                                    };
                                  },
                                )}
                                name="package_name"
                                value={
                                  values.package_name &&
                                  values.package_name.value
                                    ? values.package_name
                                    : null
                                }
                                isClearable
                                placeholder="Select Package Name"
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                onChange={async (val) => {
                                  setFieldValue("package_name", val);
                                  setFieldValue("package_id", val?.value);
                                  let franchiseIdToUse =
                                    values?.franchise_id ||
                                    _token?.franchise_id ||
                                    franchise_id;
                                  if (!values?.franchise_id) {
                                    const storedFranchiseId =
                                      localStorage.getItem(
                                        "new_registration_franchise_id",
                                      );
                                    if (storedFranchiseId) {
                                      franchiseIdToUse = storedFranchiseId;
                                    }
                                  }
                                  if (val) {
                                    const isDuplicate =
                                      values.package_details?.some(
                                        (pkg) =>
                                          pkg.package_id === val.value &&
                                          !pkg.isDisabled &&
                                          !pkg.removed,
                                      );

                                    if (isDuplicate) {
                                      alert(
                                        "This package has already been added!",
                                      );
                                      return;
                                    }

                                    if (franchiseIdToUse) {
                                      // const { data } = await axiosInstance.get(
                                      //   `medicity/master/list/franchise_package_rate/${values?.franchise_id
                                      //     ? values?.franchise_id
                                      //     : _token?.franchise_id
                                      //   }/${val?.value}`
                                      // );

                                      const { data } = await axiosInstance.get(
                                        `medicity/master/list/franchise_package_rate/${
                                          franchiseIdToUse
                                            ? franchiseIdToUse
                                            : _token?.franchise_id
                                        }/${
                                          val?.value
                                        }?appointment_booking_id=${
                                          appointmentBookingData?.id ||
                                          appointmentBookingId ||
                                          docAppointmentBookingId
                                        }${
                                          membershipCardState
                                            ? `&membership_card_no=${membershipCardState}`
                                            : ""
                                        }`,
                                      );

                                      console.log(
                                        "data[0]?.package_investigations",
                                        data[0]?.package_investigations,
                                      );
                                      console.log(
                                        "values.investigation_name_id",
                                        values,
                                      );

                                      const currentFranchise =
                                        franchiseOptions?.find(
                                          (franchise) =>
                                            franchise.franchise_id ==
                                            franchiseIdToUse,
                                        );

                                      const shouldIncludeBarcode =
                                        currentFranchise?.allow_preprint_barcode !==
                                        true;

                                      // const already =
                                      //   data[0]?.package_investigations?.filter(
                                      //     (item) =>
                                      //       item.investigation_id ==
                                      //       values.investigation_name_id
                                      //   );

                                      const already =
                                        data[0]?.package_investigations?.some(
                                          (pkgItem) =>
                                            values.investigtion_details?.some(
                                              (investigation) =>
                                                investigation.investigation_id ===
                                                pkgItem.investigation_id,
                                            ),
                                        );

                                      console.log(
                                        "Alreay Alreay Alreay Alreay Alreay ",
                                        already,
                                      );

                                      // let data1 = await axiosInstance.get(
                                      //   `medicity/rate/list/${val?.investigation_id
                                      //   }/${values?.franchise_id
                                      //     ? values?.franchise_id
                                      //     : _token?.franchise_id
                                      //   }`
                                      // );
                                      // console.log(
                                      //   "package details paymentMode 1",
                                      //   paymentMode
                                      // );
                                      // console.log(
                                      //   "package details paymentMode 2",
                                      //   values?.paymentModechk
                                      // );
                                      const rateData = data[0];
                                      // console.log(
                                      //   "package details rateData",
                                      //   rateData
                                      // );
                                      // console.log(
                                      //   "package details rateData rate",
                                      //   rateData?.rate
                                      // );

                                      if (
                                        // (paymentMode === "CREDIT" ||
                                        //   paymentMode === "CASH" ||
                                        //   values?.paymentModechk === "CREDIT" ||
                                        //   values?.paymentModechk === "CASH") &&
                                        rateData?.rate === 0 ||
                                        rateData?.mrp_rate === 0
                                      ) {
                                        alert("Please Contact To Admin !!");
                                      } else if (!already) {
                                        push({
                                          package_id: val?.value,
                                          package_name: val?.label,
                                          // investigation_id:
                                          // discount: 0,
                                          mrp: rateData?.mrp_rate,
                                          rate: rateData?.rate,
                                          package_investigations:
                                            rateData?.package_investigations?.map(
                                              (item) => ({
                                                ...item,
                                                barcode_obj: {
                                                  ...item.barcode_obj,
                                                  barcode_no:
                                                    shouldIncludeBarcode
                                                      ? item.barcode_obj
                                                          ?.barcode_no
                                                      : null,
                                                },
                                              }),
                                            ),
                                          // is_urgent: "0",
                                          // delivery_time:
                                          //   convertTimestampToDatetimeLocal(
                                          //     rateData?.generated
                                          //   ),
                                          // barcode_id: barcodedataFinal,
                                          // barcode_id_main: barcodedataFinal,
                                          // is_third_party_barcode: false,
                                          read_only: false,
                                          // sample_type: rateData?.sample_type,
                                          // delivery_days: rateData?.delivery_days,
                                          shouldIncludeBarcode:
                                            shouldIncludeBarcode,
                                        });
                                      } else {
                                        alert(
                                          "Already Investigation Available !!",
                                        );
                                      }
                                    }
                                  }

                                  if (paymentMode != "CASH") {
                                    setFieldValue("payment_mode_id", 1);
                                    setFieldValue(
                                      "paymentModechk",
                                      values.paymentModechk
                                        ? values.paymentModechk
                                        : paymentMode,
                                    );
                                    setFieldValue("amount", 0);
                                    setFieldValue("payment_mode", {
                                      value: "CASH",
                                      label: "CASH",
                                      payment_mode_id: 1,
                                    });
                                  } else {
                                    setFieldValue(
                                      "paymentModechk",
                                      values.paymentModechk
                                        ? values.paymentModechk
                                        : paymentMode,
                                    );
                                  }
                                }}
                              />
                            </div>
                            {/* <button
                      type="button"
                      className="btn btn-primary col-md-3 pt-2 pb-2 mb-3"
                      style={{ position: "relative", top: "13px" }}
                      onClick={() =>
                        push({
                          investigation_name: values.investigation_name.value,
                          mrp: "",
                        })
                      }
                    >
                      Add Investigation
                    </button> */}
                          </div>
                        </div>

                        {values.package_details?.length > 0 &&
                          values.package_details.map((field, index) => (
                            <div className="" key={index}>
                              <div
                                className="block-box"
                                style={{ opacity: field.isDisabled ? 0.5 : 1 }}
                              >
                                <div
                                  className="p-2 text-primary d-flex justify-content-between"
                                  style={{ fontSize: "14px" }}
                                >
                                  <span>
                                    {
                                      values?.package_details[index]
                                        ?.package_name
                                    }
                                  </span>
                                  {/* <span>
                                    {
                                      values?.package_details[index]
                                        ?.sample_type
                                    }
                                  </span> */}
                                </div>
                                <div className="block-title">
                                  <div
                                    className="row "
                                    style={{
                                      display: "flex",
                                      flexFlow: "wrap",
                                      width: "97%",
                                      margin: "0",
                                      gap: "10px",
                                      padding: "10px 0",
                                      float: "left",
                                    }}
                                  >
                                    <div
                                      className={`col-md-2 `}
                                      style={{
                                        width: "13%",
                                        display: "flex",
                                        flexFlow: "column",
                                        padding: "0",
                                      }}
                                    >
                                      <label className=" in-label">
                                        Test MRP
                                      </label>
                                      <Field
                                        name={`package_details.${index}.mrp`}
                                        type="number"
                                        className="text-input"
                                        disabled={true}
                                        value={
                                          values.package_details[index].mrp
                                        }
                                        onChange={(e) => {
                                          setFieldValue(
                                            `package_details.${index}.mrp`,
                                            e.target.value,
                                          );
                                          // if(values.package_details[index]
                                          //   .rate == 0){
                                          //     setFieldValue(
                                          //       `package_details.${index}.rate`,
                                          //       e.target.value
                                          //     )
                                          //   }
                                        }}
                                        style={{
                                          border:
                                            values.package_details[index].mrp <=
                                            0
                                              ? "1px solid red"
                                              : "",
                                        }}
                                      />
                                    </div>

                                    {values.paymentModechk === "CASH" ||
                                    paymentMode === "CASH" ? (
                                      <div className="col-md-2 col-12 d-flex flex-column p-0">
                                        <label className="in-label">
                                          Discount % (Amt)
                                        </label>
                                        <div className="d-flex gap-1">
                                          <Field
                                            name={`package_details.${index}.discount_percentage`}
                                            type="text"
                                            className="text-input"
                                            style={{ width: "50%" }}
                                            placeholder="%"
                                            disabled={
                                              !!membershipCardState ||
                                              paymentMode === "CREDIT" ||
                                              values?.paymentModechk ===
                                                "CREDIT"
                                            }
                                            value={
                                              membershipCardState
                                                ? values.package_details[index]
                                                    .mrp > 0
                                                  ? (
                                                      ((values.package_details[
                                                        index
                                                      ].mrp -
                                                        values.package_details[
                                                          index
                                                        ].rate) /
                                                        values.package_details[
                                                          index
                                                        ].mrp) *
                                                      100
                                                    ).toFixed(2)
                                                  : ""
                                                : values.package_details[index]
                                                    .discount_percentage || ""
                                            }
                                            onChange={(e) => {
                                              const discount = Number(
                                                e.target.value || 0,
                                              );
                                              const mrp = Number(
                                                values.package_details[index]
                                                  .mrp || 0,
                                              );

                                              const calculatedRate =
                                                mrp - (mrp * discount) / 100;

                                              setFieldValue(
                                                `package_details.${index}.discount_percentage`,
                                                discount,
                                              );

                                              setFieldValue(
                                                `package_details.${index}.rate`,
                                                Math.ceil(calculatedRate),
                                              );
                                            }}
                                          />

                                          <input
                                            type="text"
                                            className="text-input"
                                            style={{ width: "50%" }}
                                            placeholder="Amt"
                                            disabled
                                            value={
                                              values.package_details[index]
                                                .mrp &&
                                              values.package_details[index].rate
                                                ? (
                                                    values.package_details[
                                                      index
                                                    ].mrp -
                                                    values.package_details[
                                                      index
                                                    ].rate
                                                  ).toFixed(2)
                                                : values.package_details[index]
                                                    .discount || ""
                                            }
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="col-md-2 col-12 d-flex flex-column p-0">
                                        <label className="in-label">
                                          Test Discount
                                        </label>
                                        <Field
                                          name={`package_details.${index}.discount`}
                                          type="number"
                                          className="text-input"
                                          disabled
                                          value={
                                            values.package_details[index]
                                              .discount || 0
                                          }
                                          onChange={(e) =>
                                            setFieldValue(
                                              `package_details.${index}.discount`,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>
                                    )}

                                    <div
                                      className={`col-md-2 `}
                                      style={{
                                        width: "13%",
                                        display: "flex",
                                        flexFlow: "column",
                                        padding: "0",
                                      }}
                                    >
                                      <label className=" in-label">
                                        Test Rate
                                      </label>
                                      <Field
                                        name={`package_details.${index}.rate`}
                                        type="number"
                                        className="text-input"
                                        disabled={true}
                                        value={
                                          values.package_details[index].rate
                                        }
                                        onChange={(e) =>
                                          setFieldValue(
                                            `package_details.${index}.rate`,
                                            e.target.value,
                                          )
                                        }
                                        // style={{border: values.package_details[index]
                                        //   .rate <= 0  ? "1px solid red" :"" }}
                                      />
                                    </div>

                                    <div
                                      className={`col-md-2 `}
                                      style={{
                                        width: "13%",
                                        display: "flex",
                                        flexFlow: "column",
                                        padding: "0",
                                      }}
                                    >
                                      <label className=" in-label">
                                        Is Urgent
                                      </label>
                                      <Field
                                        name={`package_details.${index}.is_urgent`}
                                        type="select"
                                        className="text-input"
                                        as="select"
                                        disabled={
                                          values.package_details[index]
                                            .read_only
                                        }
                                      >
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                      </Field>
                                    </div>
                                    {/* <div
                                      className={`col-md-2 `}
                                      style={{
                                        width: "13%",
                                        display: "flex",
                                        flexFlow: "column",
                                        padding: "0",
                                      }}
                                    >
                                      <label className="in-label">DD</label>
                                      <Field
                                        name={`package_details.${index}.delivery_days`}
                                        type="number"
                                        className="text-input"
                                        disabled={true}
                                        value={
                                          values.package_details[index]
                                            .delivery_days
                                        }
                                        onChange={(e) => {
                                          setFieldValue(
                                            `package_details.${index}.delivery_days`,
                                            e.target.value
                                          );
                                        }}
                                      />
                                    </div> */}
                                    <div
                                      className={`col-md-2 `}
                                      style={{
                                        width: "13%",
                                        display: "flex",
                                        flexFlow: "column",
                                        padding: "0",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-primary mt-3"
                                        // onClick={() => openPackageView(values?.package_details[index]?.package_investigations)}
                                        onClick={() => {
                                          const updatedPackageInvestigations =
                                            JSON.parse(
                                              JSON.stringify(
                                                values.package_details[index]
                                                  ?.package_investigations ||
                                                  [],
                                              ),
                                            );

                                          console.log(
                                            "Updated Package Investigations:",
                                            updatedPackageInvestigations,
                                          ); // Debugging

                                          openPackageView(
                                            updatedPackageInvestigations,
                                            values.package_details[index]
                                              ?.shouldIncludeBarcode,
                                          );
                                        }}
                                      >
                                        View
                                      </button>
                                    </div>

                                    {values.package_details[index].is_urgent ===
                                      "1" && (
                                      <div
                                        className={`col-md-2 `}
                                        style={{
                                          width: "13%",
                                          display: "flex",
                                          flexFlow: "column",
                                          padding: "0",
                                        }}
                                      >
                                        <label className=" in-label">
                                          Urgent Delivery Time
                                        </label>
                                        <Field
                                          name={`package_details.${index}.urgent_delivery_time`}
                                          type="datetime-local"
                                          className="text-input"
                                          disabled={
                                            values.package_details[index]
                                              .read_only
                                          }
                                          value={
                                            values.package_details[index]
                                              .urgent_delivery_time
                                          }
                                          onChange={(e) =>
                                            setFieldValue(
                                              `package_details.${index}.urgent_delivery_time`,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {!appointment_id &&
                                    !field?.package_investigations?.some(
                                      (inv) =>
                                        inv?.investigation_status_obj
                                          ?.status === "APPROVED",
                                    ) && (
                                      <div
                                        onClick={() => {
                                          setPackagesIds((prev) => [
                                            ...prev,
                                            field.package_id,
                                          ]);

                                          const updatedPackageDetails =
                                            values.package_details.filter(
                                              (_, i) => i !== index,
                                            );

                                          setFieldValue(
                                            "package_details",
                                            updatedPackageDetails,
                                          );
                                        }}
                                        style={{
                                          width: "3%",
                                          float: "left",
                                          padding: "15px 0",
                                          display: "flex",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="feather feather-x"
                                        >
                                          <line x1="18" y1="6" x2="6" y2="18" />
                                          <line x1="6" y1="6" x2="18" y2="18" />
                                        </svg>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          ))}
                      </>
                    )}
                  </FieldArray>
                </>

                {/* Payment Details */}

                {/* {values.paymentModechk == "CASH" && (
                  <div
                    className="heading-form mt-4"
                    style={{ width: "100%", overflow: "hidden" }}
                  >
                    Discount & Changes
                  </div>
                )} */}

                {values.paymentModechk === "CASH" && (
                  <div className="heading-form mt-4 d-flex justify-content-between align-items-center w-100">
                    <span>Discount & Changes</span>

                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={handleShowReceipt}
                    >
                      Print Estimate
                    </button>
                  </div>
                )}

                {values.paymentModechk == "CREDIT" && (
                  <div
                    className="heading-form mt-4"
                    style={{ width: "100%", overflow: "hidden" }}
                  >
                    Charges
                  </div>
                )}

                {values.paymentModechk == "CREDIT" && (
                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Coll. Charge</label>
                    <input
                      name="coll_charge"
                      type="number"
                      className="form-control"
                      value={values.coll_charge}
                      onChange={(e) => {
                        const value = e.target.value;

                        setFieldValue("coll_charge", value);

                        if (value === "") {
                          setFieldValue("coll_charge_received", "");
                          setFieldValue("balance_coll_charge", "");
                          return;
                        }

                        const collCharge = Number(value);

                        setFieldValue("coll_charge_received", collCharge);

                        calculateCollCharge(
                          collCharge,
                          collCharge,
                          setFieldValue,
                        );
                      }}
                    />
                    {Boolean(errors.coll_charge) && (
                      <span className="text-danger">
                        {touched.coll_charge && errors.coll_charge}
                      </span>
                    )}
                  </div>
                )}

                {values.paymentModechk == "CASH" && (
                  <div className="row mt-4">
                    <div className={`col-md-3 mb-3`}>
                      <label className="mb-2">Discount Type</label>
                      <select
                        value={values.discount_type}
                        disabled
                        className="form-control"
                        onChange={(e) => {
                          setFieldValue("discount_type", e.target.value);
                          setFieldValue("discount", "");
                          setFieldValue("approved_by", "");
                          setFieldValue("approved_by_id", "");
                          setFieldValue("discount_reason", "");
                        }}
                      >
                        {[
                          {
                            key: "Employee Wise",
                            value: "Employee Wise",
                            label: "Employee Wise",
                          },
                          // {
                          //   key: "Disc Type Wise",
                          //   value: "Disc Type Wise",
                          //   label: "Disc Type Wise",
                          // },
                        ].map((option, index) => (
                          <option key={index} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {(values.discount_type === "Employee Wise" ||
                      discountType === "Employee Wise") && (
                      <>
                        <div className={`col-md-3 mb-3`}>
                          <label className="mb-2">Discount</label>
                          <div className="input-group">
                            <input
                              type="number"
                              disabled={!!appointment_id}
                              className="form-control"
                              aria-label="Text input with dropdown button"
                              value={values.discount}
                              onChange={(e) =>
                                setFieldValue("discount", e.target.value)
                              }
                            />
                            <button
                              className="btn btn-secondary dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              disabled={!!appointment_id}
                            >
                              {values.discount_unit}
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end">
                              <li
                                onClick={() => {
                                  setFieldValue("discount_unit", "Amount");
                                  setDiscountUnit("Amount");
                                }}
                              >
                                <span className="dropdown-item">Amount</span>
                              </li>

                              <li
                                onClick={() => {
                                  setFieldValue("discount_unit", "Percent");
                                  setDiscountUnit("Percent");
                                }}
                              >
                                <span className="dropdown-item">Percent</span>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div className={`col-md-3 mb-3`}>
                          <label className="mb-2">Approved By</label>
                          <Select
                            options={employeeOptions}
                            isDisabled={!!appointment_id}
                            name="approved_by"
                            isClearable
                            value={selectedEmployee}
                            placeholder="Select Approved By"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            onChange={(val) => {
                              setFieldValue("approved_by", val);
                              setFieldValue(
                                "approved_by_id",
                                val?.employee_code_id,
                              );
                            }}
                          />
                          {Boolean(errors.approved_by_id) && (
                            <span className="text-danger">
                              {touched.approved_by_id && errors.approved_by_id}
                            </span>
                          )}
                        </div>
                        <div className="col-md-3 mb-3">
                          <label className="mb-2">Discount Reason</label>

                          <select
                            value={values.discount_reason_id}
                            disabled={!!appointment_id}
                            className="form-control"
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              const selectedText =
                                e.target.options[e.target.selectedIndex].text;

                              setFieldValue("discount_reason_id", selectedId);
                              setFieldValue("discount_reason", selectedText);
                            }}
                          >
                            <option value="">Select Reason</option>

                            {discount_reason_list?.data?.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.discount_reason}
                              </option>
                            ))}
                          </select>
                        </div>
                      </>
                    )}

                    <div className={`col-md-3 mb-3`}>
                      <label className="mb-2">Coll. Charge</label>
                      <input
                        name="coll_charge"
                        type="number"
                        className="form-control"
                        disabled={!!appointment_id}
                        value={values.coll_charge}
                        onChange={(e) => {
                          const value = e.target.value;

                          // allow empty
                          setFieldValue("coll_charge", value);

                          if (value === "") {
                            setFieldValue("coll_charge_received", "");
                            setFieldValue("balance_coll_charge", "");
                            return;
                          }

                          const collCharge = Number(value);

                          setFieldValue("coll_charge_received", collCharge);

                          calculateCollCharge(
                            collCharge,
                            collCharge,
                            setFieldValue,
                          );
                        }}
                      />

                      {Boolean(errors.coll_charge) && (
                        <span className="text-danger">
                          {touched.coll_charge && errors.coll_charge}
                        </span>
                      )}
                    </div>

                    {(values.paymentModechk === "CASH" ||
                      paymentMode === "CASH") && (
                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Coll. Charge Received</label>
                        <input
                          name="coll_charge_received"
                          type="number"
                          disabled={!!appointment_id}
                          className="form-control"
                          value={values.coll_charge_received}
                          onChange={(e) => {
                            const value = e.target.value;

                            setFieldValue("coll_charge_received", value);

                            if (value === "") {
                              setFieldValue(
                                "balance_coll_charge",
                                values.coll_charge || "",
                              );
                              return;
                            }

                            calculateCollCharge(
                              Number(values.coll_charge || 0),
                              Number(value),
                              setFieldValue,
                            );
                          }}
                        />
                        {Boolean(errors.coll_charge_received) && (
                          <span className="text-danger">
                            {touched.coll_charge_received &&
                              errors.coll_charge_received}
                          </span>
                        )}
                      </div>
                    )}

                    {(values.paymentModechk === "CASH" ||
                      paymentMode === "CASH") && (
                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Balance Coll. Charge</label>
                        <input
                          name="balance_coll_charge"
                          type="number"
                          className="form-control"
                          value={values.balance_coll_charge}
                          disabled
                        />
                        {Boolean(errors.balance_coll_charge) && (
                          <span className="text-danger">
                            {touched.balance_coll_charge &&
                              errors.balance_coll_charge}
                          </span>
                        )}
                      </div>
                    )}

                    <div className={`col-md-3 mb-3`}>
                      <label className="mb-2">Add. Charge/Adjustment</label>
                      <input
                        name="adjustment"
                        disabled={!!appointment_id}
                        type="number"
                        className="form-control"
                        value={values.adjustment}
                        onChange={(e) =>
                          setFieldValue("adjustment", e.target.value)
                        }
                      />
                      {Boolean(errors.adjustment) && (
                        <span className="text-danger">
                          {touched.adjustment && errors.adjustment}
                        </span>
                      )}
                    </div>
                  </div>
                )}

                <div className="heading-form mt-3">Payment Details</div>

                <div className="row">
                  {values.paymentModechk == "CASH" && (
                    <div className={`col-md-3 mb-3`}>
                      <label className="mb-2">
                        Payment Mode<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={payment_mode_list?.data?.map((item) => {
                          return {
                            value: item.payment_mode,
                            label: item.payment_mode,
                            payment_mode_id: item.id,
                          };
                        })}
                        isDisabled={!!appointment_id}
                        name="payment_mode"
                        isClearable
                        value={values.payment_mode || null}
                        placeholder="Select payment_mode"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        onChange={(val) => {
                          setFieldValue("payment_mode", val);
                          setFieldValue(
                            "payment_mode_id",
                            val?.payment_mode_id,
                          );
                        }}
                      />
                      {Boolean(errors.payment_mode_id) && (
                        <span className="text-danger">
                          {touched.payment_mode_id && errors.payment_mode_id}
                        </span>
                      )}
                      {values.paymentModechk === "CASH" &&
                        !values.payment_mode && (
                          <span className="text-danger">
                            Payment mode is required
                          </span>
                        )}
                    </div>
                  )}

                  {values.paymentModechk == "CASH" && (
                    <div className={`col-md-3 mb-3`}>
                      <label className="mb-2">
                        Receive Amount<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        name="amount"
                        type="text"
                        className="form-control"
                        disabled={!!appointment_id}
                        // value={
                        //   manualAmount !== ""
                        //     ? manualAmount
                        //     : values.amount || ""
                        // }
                        value={manualAmount?.toString() || values.amount || ""}
                        onChange={(e) => {
                          const enteredValue = e.target.value;
                          if (enteredValue === "") {
                            setManualAmount("");
                            setManualOverride(true);
                            setFieldValue("amount", "");
                            return;
                          } else {
                            setManualOverride(false);
                          }

                          const maxAmount = calculateNetAmount(
                            sumRate(
                              values.investigtion_details,
                              values?.package_details,
                            ),
                            values?.discount_unit,
                            Number(values?.discount || 0),
                            0,
                            Number(values?.adjustment || 0),
                          );

                          if (Number(enteredValue) > maxAmount) {
                            alert(`You cannot enter more than ${maxAmount}`);
                            return;
                          }

                          setManualAmount(enteredValue);
                          setFieldValue("amount", enteredValue);
                        }}
                      />
                      {Boolean(errors.amount) && (
                        <span className="text-danger">
                          {touched.amount && errors.amount}
                        </span>
                      )}
                    </div>
                  )}

                  {values.paymentModechk == "CASH" && (
                    <div className={`col-md-3 mb-3`}>
                      <label className="mb-2">Cheque/Card Number</label>
                      <input
                        name="cheque_card_number"
                        type="text"
                        disabled={!!appointment_id}
                        className="form-control"
                        value={values.cheque_card_number}
                        onChange={(e) =>
                          setFieldValue("cheque_card_number", e.target.value)
                        }
                      />
                      {Boolean(errors.cheque_card_number) && (
                        <span className="text-danger">
                          {touched.cheque_card_number &&
                            errors.cheque_card_number}
                        </span>
                      )}
                    </div>
                  )}

                  {values.paymentModechk == "CASH" && (
                    <div className={`col-md-3 mb-3`}>
                      <label className="mb-2">Bank Name</label>
                      <input
                        name="bank_name"
                        type="text"
                        disabled={!!appointment_id}
                        className="form-control"
                        value={values.bank_name}
                        onChange={(e) =>
                          setFieldValue("bank_name", e.target.value)
                        }
                      />
                      {Boolean(errors.bank_name) && (
                        <span className="text-danger">
                          {touched.bank_name && errors.bank_name}
                        </span>
                      )}
                    </div>
                  )}

                  {/* {values.paymentModechk == "CASH" && (
                    <div className={`col-md-3 mb-3`}>
                      <label className="mb-2">Cash Rendering</label>
                      <input
                        name="cash_rendering"
                        type="number"
                        className="form-control"
                        value={values.cash_rendering}
                        onChange={(e) =>
                          setFieldValue("cash_rendering", e.target.value)
                        }
                      />
                      {Boolean(errors.cash_rendering) && (
                        <span className="text-danger">
                          {touched.cash_rendering && errors.cash_rendering}
                        </span>
                      )}
                    </div>
                  )} */}

                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Total Gross</label>
                    <input
                      name="total_gross"
                      type="text"
                      className="form-control"
                      // value={sumMRP(values.package_details)}
                      value={Math.ceil(
                        calculateNetAmount(
                          sumRate(
                            values?.investigtion_details,
                            values?.package_details,
                          ),
                        ),
                      )}
                      disabled
                    />
                  </div>

                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Total Net</label>
                    <input
                      name="total_net"
                      type="text"
                      className="form-control"
                      // value={Math.ceil(
                      //   calculateNetAmount(
                      //     values?.paymentModechk === "CASH"
                      //       ? sumMRP(
                      //           values?.investigtion_details,
                      //           values?.package_details
                      //         )
                      //       : sumRate(
                      //           values?.investigtion_details,
                      //           values?.package_details
                      //         ),
                      //     values?.discount_unit,
                      //     Number(values?.discount),
                      //     // Number(values?.coll_charge),
                      //     Number(values?.adjustment)
                      //   )
                      // )}
                      value={Math.ceil(
                        calculateNetAmount(
                          sumRate(
                            values?.investigtion_details,
                            values?.package_details,
                          ),
                          values?.discount_unit,
                          Number(values?.discount || 0),
                          0,
                          Number(values?.adjustment || 0),
                        ),
                      )}
                      disabled
                    />
                  </div>

                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Balance Amount</label>
                    <input
                      name="balance_amount"
                      type="text"
                      className="form-control"
                      value={Math.ceil(
                        calculateNetAmount(
                          sumRate(
                            values?.investigtion_details || [],
                            values?.package_details || [],
                          ),
                          values?.discount_unit,
                          Number(values?.discount || 0),
                          0, // commissionCharges
                          Number(values?.adjustment || 0),
                        ) -
                          (paymentMode === "CASH" ||
                          values?.paymentModechk === "CASH"
                            ? Number(manualAmount || values?.amount || 0)
                            : calculateNetAmount(
                                sumRate(
                                  values?.investigtion_details || [],
                                  values?.package_details || [],
                                ),
                                values?.discount_unit,
                                Number(values?.discount || 0),
                                0,
                                Number(values?.adjustment || 0),
                              )),
                      )}
                      disabled
                    />
                    {Boolean(errors.balance_amount) && (
                      <span className="text-danger">
                        {touched.balance_amount && errors.balance_amount}
                      </span>
                    )}
                  </div>
                  <div
                    className="gap-2 d-flex flex-row m-2"
                    style={{
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "5px",
                    }}
                  >
                    <label style={{ fontWeight: "bold", color: "#333" }}>
                      Total MRP :
                    </label>
                    <label
                      style={{
                        fontSize: "16px",
                        color: "#28a745",
                        fontWeight: "bold",
                      }}
                    >
                      {Math.ceil(
                        calculateNetAmount(
                          sumMRP(
                            values.investigtion_details,
                            values?.package_details,
                          ),
                        ),
                      )}
                    </label>
                  </div>
                  {values.paymentModechk === "CASH" ||
                    (paymentMode === "CASH" && (
                      <div
                        className="gap-2 d-flex flex-row m-2"
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          borderRadius: "5px",
                        }}
                      >
                        <label style={{ fontWeight: "bold", color: "#333" }}>
                          Total Discount :
                        </label>
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#dc3545",
                            fontWeight: "bold",
                          }}
                        >
                          {totalDiscount.toFixed(2)}
                        </label>
                      </div>
                    ))}
                </div>
                <button
                  type="submit"
                  className="btn btn-primary mt-4"
                  ref={submitButtonRef}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Adding..." : "Add"}
                </button>
                {new_registration && new_registration?.patient_id && (
                  <>
                    {paymentMode === "CASH" && (
                      <Link to={receptUrl} className="acc-link">
                        {" "}
                        <button
                          className="btn btn-primary mt-4"
                          style={{ marginLeft: "20px" }}
                        >
                          Receipt
                        </button>
                      </Link>
                    )}
                    <p
                      className="pt-3"
                      style={{
                        paddingLeft: "3px",
                        color: "black",
                        fontWeight: "bolder",
                      }}
                    >
                      Your Appoinment ID is :{new_registration?.appointment_id}
                    </p>
                  </>
                )}

                {/* {investigationval > 0 && (
                  <p className="text-danger pt-3">
                    Investigation Mrp Should be greater than 0 !.
                  </p>
                )} */}
              </Form>
            </FormikProvider>
          </>
        </div>
      </div>

      {paymentMode === "CASH" && (
        <Offcanvas
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          placement="end"
          style={{ width: "50%" }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              style={{
                fontSize: "24px",
                fontWeight: "700",
                width: "100%",
                textAlign: "center",
              }}
            >
              Receipt
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="p-0">
            {receptUrl && (
              <iframe
                src={receptUrl}
                width="100%"
                height="100%"
                style={{ border: "none", minHeight: "100vh" }}
                title="Receipt"
              />
            )}
          </Offcanvas.Body>
        </Offcanvas>
      )}

      {isAddDoctorsOpen && (
        <Modal
          type="modal-lg"
          show={isAddDoctorsOpen}
          onHide={() => setIsAddDoctorsOpen(false)}
          modalName={MODALS.ADD_DOCTOR_MODAL}
          title="Add Doctor"
          body={
            <AddDoctor
              onClose={handleDoctorClose}
              handleDocuments={handleDocuments}
            />
          }
        />
      )}

      {isAddAgentOpen && (
        <Modal
          type="modal-lg"
          show={isAddAgentOpen}
          onHide={() => setIsAddAgentOpen(false)}
          modalName={MODALS.ADD_PATIENT_COORDINATOR_AGENTS_MODAL}
          title="Add Agent"
          body={
            <AddEmployee
              onClose={handleAgentClose}
              // handleDocuments={handleDocuments}
            />
          }
        />
      )}

      {isAddPatientOpen && (
        <Modal
          type="modal-lg"
          show={isAddPatientOpen}
          onHide={() => setIsAddPatientOpen(false)}
          modalName={MODALS.ADD_PATIENT_MODAL}
          title="Add Patient"
          body={
            <AddPatient
              onClose={handlePatientClose}
              // handleDocuments={handleDocuments}
            />
          }
        />
      )}

      {paymentMode === "CASH" && showHiddenReceipt && (
        <div
          style={{
            position: "fixed",
            left: "-9999px",
            top: "0",
            pointerEvents: "none",
            zIndex: -1,
            width: "1000px",
            overflow: "hidden",
          }}
        >
          <NewRegistrationPatientReceipt
            appointmentId={new_registration?.appointment_id}
            patientId={new_registration?.patient_id}
            membershipCardNo={membershipCardState}
            setMembershipCardState={setMembershipCardState}
            onDownloadComplete={() => setShowHiddenReceipt(false)}
            hidden={true}
          />
        </div>
      )}

      <Offcanvas
        show={showPatientModal}
        onHide={() => setShowPatientModal(false)}
        placement="end"
        style={{ width: "50%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Select Patient</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p className="mb-3">Multiple patients found. Please select one:</p>

          <div className="d-flex flex-column gap-3">
            {patientList.map((patient, index) => (
              <div key={index} className="form-check border rounded p-3">
                <input
                  className="form-check-input"
                  type="radio"
                  name="patientSelection"
                  id={`patient-${index}`}
                  checked={selectedPatientIndex === index}
                  onChange={() => setSelectedPatientIndex(index)}
                />
                <label
                  className="form-check-label w-100 cursor-pointer"
                  htmlFor={`patient-${index}`}
                >
                  <div className="ms-2">
                    <h6 className="mb-2">{patient.patient_name}</h6>
                    <div className="text-muted small">
                      <div>Mobile: {patient.mobile}</div>
                      <div>Age: {patient.age?.year || 0} years</div>
                      <div>Gender: {patient.gender}</div>
                      {patient.appointment_booking_id && (
                        <div className="mt-1">
                          <span className="badge bg-info">
                            Booking ID: {patient.appointment_booking_id}
                          </span>
                        </div>
                      )}
                      {patient?.memberships_orders[0]?.membership_card_no && (
                        <div className="mt-1">
                          <span className="badge bg-success">
                            Membership Card No:{" "}
                            {patient?.memberships_orders[0]?.membership_card_no}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </label>
              </div>
            ))}
          </div>

          <div className="mt-4">
            <button
              className="btn btn-primary w-100"
              onClick={handlePatientSelect}
              disabled={selectedPatientIndex === null}
            >
              Select Patient
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default RegistrationForm;
